import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  Sheet,
  SheetContent,
  SheetOverlay,
  SheetPortal,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Skeleton } from "@/components/ui/skeleton";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import {
  OpportunityContactType,
  PartnerInteractionType,
} from "@/lib/validations/schema";
import { zodResolver } from "@hookform/resolvers/zod";
import { PopoverClose } from "@radix-ui/react-popover";
import { ColumnDef } from "@tanstack/react-table";
import axios, { AxiosRequestConfig } from "axios";
import {
  channel_options,
  close_reason_options,
  opportunity_status_options,
  partner_contact_status,
} from "common/filters";
import { Img, Spinner } from "components";
import { DataTableColumnHeader } from "components/Table/data-table-column-header";
import { DataTable } from "components/Table/DataTable";
import {
  Bell,
  ChevronDown,
  ChevronUp,
  Mail,
  MoreVertical,
  Phone,
  PlusIcon,
  ThumbsDown,
  X,
  XIcon,
} from "lucide-react";
import DocPopup from "pages/Create Opportunities/popup/docpopup";
import EmailPopup from "pages/Create Opportunities/popup/emailpopup";
import { ChannelOptions } from "pages/Leads/lead";
import { useEffect, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import ReactSelect, { SingleValue } from "react-select";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  clearReminderPatch,
  ClearReminderReqType,
  CreateLeadOrder,
  CreateLeadOrderReqType,
  GenerateSummary,
  GenerateSummaryReqType,
  postAddInteractions,
  PostAddInteractionsReqType,
  putUpdateInteractionStatus,
  PutUpdateInteractionStatusReqType,
  putUpdateOpportunityStatus,
  PutUpdateOpportunityStatusReqType,
  requestDoc,
  RequestDocReqType,
  searchContact,
  SearchContactReqType,
} from "service/apis/Opportunities";
import {
  editPartnerDetail,
  EditPartnerDetailRequestType,
} from "service/apis/PartnerDetails";
// Same signature, answered by the new backend. See legacy-partner-api.ts.
import {
  getPartnerDetails,
  GetPartnerDetailsRequestType,
} from "service/moneeflo/legacy-partner-api";
// Same signature, answered by the new backend. See legacy-lookup-api.ts.
import { getRelationShipManager } from "service/moneeflo/legacy-lookup-api";
import {
  getAllStaff,
  GetAllStaffRequestType,
} from "service/apis/StaffDetailsapi";
import { toast } from "sonner";
import { setResumeForm } from "../../redux/features/PartnerRegistration";
import { AddPeople } from "./addpeople";
import { DateTimePicker } from "./dateandtime";
import { OrderDetail, orderDetailSchema } from "./orderdetailform";
import PhotoUpload from "./PhotoUpload";
import { Option } from "./types";
import {
  channel_options_inbound,
  channel_options_outbound,
  formatDate,
  getRelativeDate,
  partnerSheetTabs,
} from "./utils/featureRule";
import { contactInsheet, contactInsheetDetail } from "./utils/icons";
import { useSelectState } from "./utils/useSelect";
import { makeContactPrimary } from "service/apis/customerapp";
import { SelectIcon } from "@radix-ui/react-select";
import { convertFileToBase64 } from "pages/CreateRemit/documentation";
import { handleDownloadViaURL } from "utils";
import { DigitalInterestDropdown } from "components/DigitalInterest";
import { partnerInterestItems } from "components/DigitalInterest/items";
import { useDigitalMutation } from "./utils/useDigitalMutation";
import { stageTags } from "./opportunitydetails";
import { useMutation } from "react-query";
import { update_stage } from "./apis";
import { useIsMobile } from "@/hooks/use-mobile";
import { ForexOrderInteractionCard } from "pages/PartnerDetails/Common/interactionCard";

const Partnerleaddetail = () => {
  const methods = useForm<OrderDetail>({
    resolver: zodResolver(orderDetailSchema),
    mode: "onChange",
  });
  //  const rowData: any = {};
  const [isOpen, setIsOpen] = useState(false);
  const [rowData, setRowData] = useState<OpportunityContactType | null>(null);
  const getOpportunityList = () => Promise.resolve();
  const [selectedChannelOption, setSelectedChannelOption] =
    useState<string>("");
  const [selectedLeadStatus, setSelectedLeadStatus] = useState();
  const [interactionNote, setInteractionNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState<Date>();
  const [meetingTime, setMeetingTime] = useState<Date>();
  const [opportunityDetails, setOpportunityDetails] = useState<any>({});
  const [productDetails, setProductDetails] = useState<any>({});
  const [interactionList, setInteractionList] = useState<
    PartnerInteractionType[]
  >([]);
  const [selectedRowData, setSelectedRowData] =
    useState<OpportunityContactType | null>(null);
  const [contactDetails, setContactDetails] = useState<{
    contactPerson: string;
    contactEmail: string;
    contactNumber: string;
    location: string;
    stage_tags?: string;
    notes: string;
    oppId: string;
    contactId: string;
    createDate: string;
    createdBy: string;
    type: string;
    city: string;
    _created_by: {
      fname: string;
    };
    _rm: {
      id: string;
      fname: string;
    };
    lead_status: string;
    digital_interest?: string;
  }>();

  const isMobile = useIsMobile();
  const [extraDetails, setExtraDetails] = useState<any>();
  const [status, setStatus] = useState<any>();
  const { pipelineType } = useAppSelector((state) => state.CreateOpportunity);
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const [selectedMode, setSelectedMode] = useState<string[]>([]);
  const [expires, setExpires] = useState("1");
  const [channelDetails, setChannelDetails] = useState<{
    channel: string;
    source: string;
  }>();
  const [channel, setChannel] = useState("whatsapp");
  const [popupnotes, setPopupNotes] = useState<string>("");
  const [staffs, setStaffs] = useState<Option[]>([]);
  const [selectedStaffOptions, setSelectedStaffOptions] = useState<Option[]>(
    [],
  );
  const [visitingCard, setVisitingCard] = useState({
    filename: "",
    filetype: "",
    fileBase64: "",
  });

  const [summary, setSummary] = useState("");
  const [activeTab, setActiveTab] = useState("interaction");
  const [followupNote, setFollowupNote] = useState("");
  const [detailNotes, setDetailNotes] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [isClearReminder, setIsClearReminder] = useState(false);
  const [editReminder, setEditReminder] = useState(false);
  const [selectedType, setSelectedType] = useState<string>("");
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [showBothButtons, setShowBothButtons] = useState(true);
  const [selectedContact, setSelectedContact] = useState("");
  const [contacts, setContacts] = useState<{ id: string; name: string }[]>([]);
  const [contactType, setContactType] = useState("");
  const [teamMember, setTeamMember] = useState<
    {
      id: number;
      contactName: string;
      contactNumber: string;
      contactEmail: string;
      channels_id: string;
      linked_partner_id: string;
      partner_link_time: number;
      _partner_linked_by: object;
      isPrimary: boolean;
      relation_with_partner: string;
    }[]
  >([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [location, setLocation] = useState<{
    latitude: string;
    longitude: string;
  } | null>(null);
  const [isPhotoUploaded, setIsPhotoUploaded] = useState(false);
  const [reminderTime, setReminderTime] = useState<Date | null>(null);
  const [showInitialOptions, setShowInitialOptions] = useState(true);
  const [primaryContact, setPrimaryContact] = useState<{
    contactName: string;
    contactNumber: string;
    contactEmail: string;
    channels_id: number;
    linked_partner_id: number;
    isPrimary: boolean;
    partner_link_time: number | null;
    partner_linked_by: number;
  }>({
    contactName: "",
    contactNumber: "",
    contactEmail: "",
    channels_id: 0,
    linked_partner_id: 0,
    isPrimary: false,
    partner_link_time: null,
    partner_linked_by: 0,
  });

  const [isInteractionModal, setIsInteractionModal] = useState(false);
  const [isUploadScreen, setISUploadScreen] = useState<Boolean>(false);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [isNextBtn, setIsNextBtn] = useState<Boolean>(false);
  const [personalInfoTabOpen, setPersonalInfoTabOpen] =
    useState<boolean>(false);

  const methods2 = useForm();
  const param = useParams();
  const dispatch = useAppDispatch();
  const { resume_form } = useAppSelector((state) => state.PartnerRegistration);

  const inboundOptions = [
    { label: "Meeting", value: 3 },
    { label: "Chat", value: 4 },
    { label: "Call", value: 1 },
    { label: "Email", value: 2 },
  ];

  const outboundOptions = [
    { label: "Meeting", value: 3 },
    { label: "Call", value: 5 },
    { label: "Email", value: 6 },
  ];

  const requestLocation = async () => {
    setLoading(true);
    if ("geolocation" in navigator) {
      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });
        setLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
        setLoading(false);
        return true;
      } catch (error) {
        console.error("Error getting location:", error);
        setLoading(false);
        return false;
      }
    } else {
      console.error("Geolocation is not supported");
      setLoading(false);
      return false;
    }
  };

  const handleReset = (e) => {
    e.stopPropagation();
    setSelectedChannel(null);
    setSelectedContact("");
    setShowInitialOptions(true);
    setSelectedType(null);
  };

  const getSelectedLabel = (type, value) => {
    const options = type === "inbound" ? inboundOptions : outboundOptions;
    const selected = options.find((opt) => opt.value.toString() === value);
    return selected ? selected.label : "";
  };

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      // Location is captured when the browser offers it and ignored when
      // it does not: nothing stores it, so it must not gate the submit.
      await requestLocation();
      if (selectedChannelOption === "3") {
        setDialogOpen(true);
      } else {
        await handleAddInteraction();
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    const getLocation = async () => {
      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });
        setLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
        setLoading(false);
        return true;
      } catch (error) {
        setLoading(false);
        return false;
      }
    };

    getLocation();
  }, []);

  const handlePhotoSubmit = (data) => {
    const submissionData = {
      ...data,
      location: location,
    };
    console.log("Submitting with location:", submissionData);
    setIsPhotoUploaded(true);
  };

  const isFormValid = () => {
    return methods2.formState.isDirty && location !== null && isPhotoUploaded;
  };

  const createOrder = async () => {
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<CreateLeadOrderReqType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      data: {
        opportunity_id: rowData?.id as string,
        order: {
          invoice_Date: methods.getValues("invoice_date"),
          invoice_ID: methods.getValues("invoice_id").toString(),
          amount: methods.getValues("amount").toString(),
          notes: methods.getValues("notes") as string,
        },
      },
    };
    try {
      const res = (await CreateLeadOrder(payload)) as any;
      if (res.status === 200) {
        toast.success("Order created successfully");
        await getOpportunityList?.();
        setLoading(false);
        methods.reset();
      }
    } catch (error) {
      toast.error("Failed to create order");
      setLoading(false);
    }
  };

  const getOpportunity = async () => {
    try {
      const auth = localStorage.getItem("authToken");
      if (!auth) return;

      const authToken = JSON.parse(auth);
      const payload: AxiosRequestConfig<GetPartnerDetailsRequestType> = {
        headers: { Authorization: `Bearer ${authToken}` },
        data: {
          channels_id: param?.id,
        },
      };

      const response = await getPartnerDetails(payload);
      if (!response?.data) return;

      const channelInfo = response.data.channel_info;
      if (!channelInfo) return;

      // Set team member data with proper null checking
      if (Array.isArray(response.data.team_member)) {
        setTeamMember(response.data.team_member);
      } else {
        setTeamMember([]);
      }

      setOpportunityDetails({});
      setProductDetails({});
      setContactDetails(() => {
        return {
          contactPerson: channelInfo?.name,
          contactEmail: channelInfo?.email,
          contactNumber: channelInfo?.phone || "NA",
          location: channelInfo?.city,
          notes: "",
          contactId: channelInfo?.id,
          oppId: "",
          lead_status: channelInfo?.lead_status,
          createDate: getRelativeDate(channelInfo?.created_at),
          type: channelInfo?.type,
          _created_by: {
            fname: channelInfo?._created_by?.fname,
          },
          _rm: {
            fname: channelInfo?._rm?.fname,
          },
          digital_interest: channelInfo?.digital_interest || "",
          stage_tags: channelInfo?.stage_tags || "",
        };
      });

      setExtraDetails(channelInfo?.extra_detail || {});
      setChannelDetails({});
      setNote("");

      // Check if team_member array exists and is an array
      const teamMembers = response?.data?.team_member;

      if (Array.isArray(teamMembers) && teamMembers.length > 0) {
        const primary = teamMembers.find(
          (member) => member.isPrimary_partner === true,
        );

        if (primary) {
          setPrimaryContact({
            contactName: primary.full_name,
            contactNumber: primary.phone_number,
            contactEmail: primary.email,
          });
        }
      } else {
        const customers = response?.data?.channel_info?._customers;
        const contacts = response?.data?.channel_info?.contacts;

        const finaldata =
          customers &&
          typeof customers === "object" &&
          Object.keys(customers).length > 0
            ? customers
            : contacts;

        if (finaldata) {
          setPrimaryContact({
            contactName: finaldata.full_name,
            contactNumber: finaldata.phone_number,
            contactEmail: finaldata.email,
          });
        }
      }

      // Optional fallback if team_member is invalid
      if (!Array.isArray(teamMembers)) {
        setTeamMember([]);
      }

      setStatus(() => {
        const status = opportunity_status_options.find(
          (status) =>
            status.value === (channelInfo.status === "lead" ? "open" : "close"),
        );
        return status;
      });

      // Set interaction list data
      setInteractionList(
        channelInfo.interactions_id?.map((interaction: any) => {
          const interactionData = interaction[0];
          return {
            id: interactionData.id,
            createdAt: getRelativeDate(interactionData.created_at),
            contactedBy:
              interactionData?.channel_of_interaction_id === 3
                ? interactionData.meetingStaff_id?.map(
                    (staff: any) => staff.fname,
                  )
                : interactionData?.createdBy,
            contatedTo: interactionData?.contact_with?.full_name ?? "N/A",
            channel: interactionData._channel_of_interaction?.[0]?.Channel,
            channelType: interactionData._channel_of_interaction?.[0]?.Type,
            note: interactionData.note,
            selfie: interactionData?.selfie?.url,
            documents: interactionData?.documents_id?.map((item: any) => {
              return {
                url: item?.document?.url || "",
                name:
                  `${item?.doc_name}.${item?.document?.name
                    ?.split(".")
                    ?.at(-1)}` || "",
              };
            }),
          };
        }) ?? [],
      );
    } catch (error) {
      console.error("Error fetching opportunity details:", error);
      setTeamMember([]); // Set empty array as fallback
    }
  };

  const handleUpdateInteractionStatus = async (id: string) => {
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<PutUpdateInteractionStatusReqType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      data: {
        id,
        isOpen: "false",
      },
    };
    try {
      const res = (await putUpdateInteractionStatus(payload)) as any;
      if (res.status === 200) {
        toast.success("Interaction status updated successfully");
        await getOpportunity();
        setLoading(false);
      }
    } catch (error) {
      toast.error("Failed to update interaction status");
      setLoading(false);
    }
  };
  interface ClearReminderProps {
    onSuccess?: () => Promise<void>;
    setLoading: (loading: boolean) => void;
  }

  const clearReminder = async ({
    onSuccess,
    setLoading,
  }: ClearReminderProps) => {
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    try {
      const response = await axios.patch(
        "https://xxl6-bbr3-kxzs.m2.xano.io/api:rNhSdWJ8:UAT/editPartnerDetail",
        {
          partner_id: param?.id,
          staff_id: 0,
          reminder_time: 0,
          removeReminder: true,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "X-Branch": `${import.meta.env.VITE_X_BRANCH}`,
            "X-Data-Source": `${import.meta.env.VITE_X_DATA_SOURCE}`,
          },
        },
      );

      if (response.status === 200) {
        toast.success("Reminder cleared successfully");
        setEditReminder(true);
        if (onSuccess) {
          await onSuccess();
        }
      }
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to clear reminder";
      toast.error(errorMessage);
      console.error("Clear reminder error:", error);
    } finally {
      setLoading(false);
    }
  };
  const changeLeadStatus = async ({ onSuccess }) => {
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    try {
      const response = await axios.patch(
        "https://xxl6-bbr3-kxzs.m2.xano.io/api:rNhSdWJ8:UAT/editPartnerDetail",
        {
          partner_id: param?.id,
          lead_status: selectedLeadStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "X-Branch": `${import.meta.env.VITE_X_BRANCH}`,
            "X-Data-Source": `${import.meta.env.VITE_X_DATA_SOURCE}`,
          },
        },
      );

      if (response.status === 200) {
        toast.success("Lead Status Changed");
        await getOpportunity();
      }
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to change the status";
      toast.error(errorMessage);
      console.error("lead status error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateOpportunity = async (
    reason: string,
    followup_time: Date | string | null,
    followup_note: string,
  ) => {
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    let payload: AxiosRequestConfig<PutUpdateOpportunityStatusReqType> = {
      headers: { Authorization: `Bearer ${authToken}` },
    };
    if (followup_time === null) {
      payload.data = {
        id: rowData?.id as string,
        followup_time: "",
        reminder_note: "",
      };
    }

    // For reassignment
    if (
      !reason &&
      !followup_time &&
      !followup_note &&
      relationShipManagerSelectedOption
    ) {
      try {
        // Validate staff selection
        if (!relationShipManagerSelectedOption?.value) {
          toast.error("Please select a staff member");
          setLoading(false);
          return;
        }

        const partnerId = Number(param?.id);
        if (!partnerId || partnerId < 1) {
          throw new Error("Invalid partner ID");
        }

        const response = await axios.patch(
          "https://xxl6-bbr3-kxzs.m2.xano.io/api:rNhSdWJ8:UAT/editPartnerDetail",
          {
            partner_id: partnerId,
            staff_id: Number(relationShipManagerSelectedOption.value),
            reminder_time: 0,
            removeReminder: false,
          },
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
              "X-Branch": `${import.meta.env.VITE_X_BRANCH}`,
              "X-Data-Source": `${import.meta.env.VITE_X_DATA_SOURCE}`,
            },
          },
        );

        if (response.status === 200) {
          toast.success("Staff reassigned successfully");
          await getOpportunity(); // Refresh the data
        }
      } catch (error: any) {
        const errorMessage =
          error.response?.data?.message || "Failed to reassign staff";
        toast.error(errorMessage);
        console.error("Reassignment error:", error);
      } finally {
        setLoading(false);
      }
      return;
    }

    // For reminder setting
    if (followup_time) {
      try {
        const response = await axios.patch(
          "https://xxl6-bbr3-kxzs.m2.xano.io/api:rNhSdWJ8:UAT/editPartnerDetail",
          {
            partner_id: Number(param?.id), // Get partner ID from params
            staff_id: 0,
            reminder_time: followup_time,
            reminder_note: followup_note,
          },
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
              "X-Branch": `${import.meta.env.VITE_X_BRANCH}`,
              "X-Data-Source": `${import.meta.env.VITE_X_DATA_SOURCE}`,
            },
          },
        );

        if (response.status === 200) {
          toast.success("Reminder updated successfully");
          await getOpportunity(); // Refresh the data
        }
      } catch (error: any) {
        const errorMessage =
          error.response?.data?.message || "Failed to set reminder";
        toast.error(errorMessage);
        console.error("Reminder setting error:", error);
      } finally {
        setLoading(false);
      }
      return;
    }

    // For closing opportunity with reason
    if (reason && !followup_time && !followup_note) {
      const payload: AxiosRequestConfig<PutUpdateOpportunityStatusReqType> = {
        headers: { Authorization: `Bearer ${authToken}` },
        data: {
          id: rowData?.id as string,
          reasonToClose: reason,
          isopen: "false",
        },
      };

      try {
        const res = await putUpdateOpportunityStatus(payload);
        if (res.status === 200) {
          toast.success("Lead status updated successfully");
          setReason("");
          await getOpportunityList?.();
        }
      } catch (error) {
        toast.error("Failed to update lead status");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSetAsPrimary = async (contacts_id) => {
    try {
      const auth = localStorage.getItem("authToken");
      const authToken = JSON.parse(auth);
      if (!authToken) {
        toast.error("Authentication token not found. Please log in again.");
        return;
      }

      const response = await makeContactPrimary(
        { contacts_id, primary: true },
        authToken,
      );
      toast.success("Contact set to primary");
      await getOpportunity();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to set as primary";
      toast.error(errorMessage);
    }
  };

  const handlePartnerUpdate = async (
    partnerId: number,
    staffId: number,
    reminderTime: Date | null,
    followupNote: string,
  ) => {
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (!auth) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<EditPartnerDetailRequestType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      data: {
        partner_id: partnerId,
        staff_id: staffId,
        reminder_time: reminderTime ? reminderTime.getTime() : 0,
        reminder_note: followupNote,
        note: inputValue,
      },
    };

    try {
      const response = await editPartnerDetail(payload);
      await getOpportunity();
      if (response?.status === 200) {
        setOpportunityDetails({
          id: staffId,
          assignedTo: relationShipManagerSelectedOption?.label || "",
        });
        if (relationShipManagerSelectedOption?.label) {
          localStorage.setItem(
            "owner_name",
            relationShipManagerSelectedOption.label,
          );
        }
        if (reminderTime) {
          toast.success("Reminder updated successfully");
        } else {
          toast.success("Lead status updated successfully");
        }
        setOpportunityDetails(() => {
          return {
            id: relationShipManagerSelectedOption?.value,
            assignedTo: relationShipManagerSelectedOption?.label,
          };
        });
      }
    } catch (error) {
      toast.error("Failed to update partner details");
    } finally {
      setLoading(false);
    }
  };

  const handleAddInteraction = async () => {
    setLoading(true);
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<PostAddInteractionsReqType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      data: {
        meeting_time: date,
        meetingStaff_id: selectedStaffOptions?.map((staff) =>
          Number(staff.value),
        ),
        note: interactionNote,
        channel_of_interaction_id: selectedChannelOption,
        quotation_pdf: "",
        contact: selectedContact,
        partner_id: param?.id,
        selfie_image: methods2.getValues("office_photo") as string,
        geo_coordinates: {
          type: "point",
          data: {
            lng: location?.longitude as string,
            lat: location?.latitude as string,
          },
        },
        visiting_card: visitingCard.fileBase64,
      },
    };
    try {
      const res = (await postAddInteractions(payload)) as any;
      if (res.status === 200) {
        toast.success("Interaction added successfully");
        await getOpportunity();
        setInteractionNote("");
        setMeetingTime(undefined);
        setSelectedStaffOptions([]);
        setSelectedContact("");
        setSelectedChannelOption("");
        setContactType("");
        methods2.reset();
        setLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add interaction");
      setLoading(false);
    }
  };

  const fetchContactList = async () => {
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<SearchContactReqType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      params: {
        type: "retail",
        searchQuery: "",
      },
    };
    setLoading(true);
    try {
      const response = (await searchContact(payload)) as any;
      if (response?.data?.length === 0) return;
      const newOptions: { id: string; name: string }[] =
        response?.data?.items?.map((item: any) => {
          return {
            id: item?.id,
            name: item?.contactName,
          };
        });
      setContacts(newOptions);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching options:", error);
    }
  };

  const InteractionColumn = useMemo<ColumnDef<PartnerInteractionType>[]>(
    () => [
      {
        id: "createdAt",
        accessorKey: "createdAt",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title="Date and Time" />
        ),
        cell: ({ row }) => {
          return (
            <div className="flex flex-col gap-1.5">
              <p className="">{row.original.createdAt}</p>
              <p className="capitalize font-normal text-sm text-[#666666]">
                {row?.original?.createdBy}
              </p>
            </div>
          );
        },
      },
      {
        accessorKey: "contactedBy",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title="Contacted By" />
        ),
        cell: ({ row }) => {
          return (
            <div className="flex items-center gap-1.5">
              <div className="flex flex-col gap-1">
                {row?.original?.contactedBy?.length > 0 ? (
                  <p className="capitalize whitespace-nowrap font-normal text-sm text-[#666666]">
                    {row?.original?.contactedBy?.[0]}
                    <span>
                      {row?.original?.contactedBy?.length > 1 &&
                        ` + ${row?.original?.contactedBy?.length - 1} more`}
                    </span>
                  </p>
                ) : (
                  <p className="capitalize whitespace-nowrap font-normal text-sm text-[#666666]">
                    <span>{row?.original?.contactedBy?.fname || "N/A"}</span>
                  </p>
                )}
              </div>
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger className="w-full flex items-end " asChild>
                    <div className="pt-1">
                      {row?.original?.contactedBy?.length > 0 && (
                        <svg
                          width="15"
                          height="14"
                          viewBox="0 0 15 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.23438 0.09375C5.86845 0.09375 4.5332 0.498795 3.39747 1.25766C2.26174 2.01653 1.37655 3.09514 0.853835 4.35709C0.331117 5.61904 0.194351 7.00766 0.46083 8.34734C0.727309 9.68702 1.38507 10.9176 2.35092 11.8835C3.31678 12.8493 4.54735 13.5071 5.88704 13.7735C7.22672 14.04 8.61533 13.9033 9.87729 13.3805C11.1392 12.8578 12.2178 11.9726 12.9767 10.8369C13.7356 9.70118 14.1406 8.36593 14.1406 7C14.1387 5.16894 13.4105 3.41343 12.1157 2.11868C10.8209 0.823925 9.06544 0.0956836 7.23438 0.09375ZM6.96875 3.28125C7.12636 3.28125 7.28043 3.32799 7.41147 3.41555C7.54252 3.50311 7.64466 3.62756 7.70497 3.77317C7.76528 3.91878 7.78106 4.07901 7.75032 4.23359C7.71957 4.38817 7.64367 4.53016 7.53223 4.6416C7.42078 4.75305 7.27879 4.82894 7.12422 4.85969C6.96964 4.89044 6.80941 4.87466 6.6638 4.81434C6.51819 4.75403 6.39374 4.65189 6.30618 4.52084C6.21861 4.3898 6.17188 4.23573 6.17188 4.07812C6.17188 3.86678 6.25583 3.66409 6.40528 3.51465C6.55472 3.36521 6.75741 3.28125 6.96875 3.28125ZM7.76563 10.7188C7.48384 10.7188 7.21358 10.6068 7.01433 10.4076C6.81507 10.2083 6.70313 9.93804 6.70313 9.65625V7C6.56223 7 6.42711 6.94403 6.32748 6.8444C6.22785 6.74477 6.17188 6.60965 6.17188 6.46875C6.17188 6.32785 6.22785 6.19273 6.32748 6.0931C6.42711 5.99347 6.56223 5.9375 6.70313 5.9375C6.98492 5.9375 7.25517 6.04944 7.45443 6.2487C7.65369 6.44796 7.76563 6.71821 7.76563 7V9.65625C7.90652 9.65625 8.04165 9.71222 8.14128 9.81185C8.24091 9.91148 8.29688 10.0466 8.29688 10.1875C8.29688 10.3284 8.24091 10.4635 8.14128 10.5632C8.04165 10.6628 7.90652 10.7188 7.76563 10.7188Z"
                            fill="#666666"
                          />
                        </svg>
                      )}
                    </div>
                  </TooltipTrigger>
                  <TooltipContent className="bg-black-label border-0">
                    <p className="bg-black-label text-white-A700">
                      {row?.original?.contactedBy?.length
                        ? row?.original?.contactedBy
                            ?.map((staff: any) => {
                              return staff;
                            })
                            .join(", ")
                        : "No staffs available"}
                    </p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>
          );
        },
        enableSorting: false,
      },
      {
        accessorKey: "contatedTo",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title="Contacted With" />
        ),
        cell: ({ row }) => {
          return (
            <div className="flex items-center justify-between gap-1.5">
              <p className="max-w-[200px] whitespace-normal break-words">
                {row.original.contatedTo}
              </p>
            </div>
          );
        },
        enableSorting: false,
      },
      {
        accessorKey: "channel",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title="Channel" />
        ),
        cell: ({ row }) => {
          const newSource = (channel_options as ChannelOptions)?.[
            row?.original?.channelType?.toLowerCase()
          ]?.find(
            (item) =>
              item.value?.toLowerCase() ===
              (row.getValue("channel") as string)
                ?.toLowerCase()
                .split(" ")
                .join(""),
          );

          if (newSource?.value === "meeting") {
            return (
              <div className="h-full max-w-[100px] items-start flex gap-10 ">
                <div className="flex flex-col gap-1">
                  <p className="capitalize">{newSource?.label}</p>
                  <p className="capitalize text-gray-500">
                    {row?.original?.channelType}
                  </p>
                  {/* {row?.original?.contactedBy?.length > 0 && (
                    <p className="capitalize whitespace-nowrap font-normal text-sm text-[#666666]">
                      {row?.original?.contactedBy?.[0]}
                      <span>
                        {row?.original?.contactedBy?.length > 1 &&
                          ` + ${row?.original?.contactedBy?.length - 1} more`}
                      </span>
                    </p>
                  )} */}
                </div>
                {/* <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger className="w-full flex items-end " asChild>
                      <div className="pt-1">
                        <svg
                          width="15"
                          height="14"
                          viewBox="0 0 15 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.23438 0.09375C5.86845 0.09375 4.5332 0.498795 3.39747 1.25766C2.26174 2.01653 1.37655 3.09514 0.853835 4.35709C0.331117 5.61904 0.194351 7.00766 0.46083 8.34734C0.727309 9.68702 1.38507 10.9176 2.35092 11.8835C3.31678 12.8493 4.54735 13.5071 5.88704 13.7735C7.22672 14.04 8.61533 13.9033 9.87729 13.3805C11.1392 12.8578 12.2178 11.9726 12.9767 10.8369C13.7356 9.70118 14.1406 8.36593 14.1406 7C14.1387 5.16894 13.4105 3.41343 12.1157 2.11868C10.8209 0.823925 9.06544 0.0956836 7.23438 0.09375ZM6.96875 3.28125C7.12636 3.28125 7.28043 3.32799 7.41147 3.41555C7.54252 3.50311 7.64466 3.62756 7.70497 3.77317C7.76528 3.91878 7.78106 4.07901 7.75032 4.23359C7.71957 4.38817 7.64367 4.53016 7.53223 4.6416C7.42078 4.75305 7.27879 4.82894 7.12422 4.85969C6.96964 4.89044 6.80941 4.87466 6.6638 4.81434C6.51819 4.75403 6.39374 4.65189 6.30618 4.52084C6.21861 4.3898 6.17188 4.23573 6.17188 4.07812C6.17188 3.86678 6.25583 3.66409 6.40528 3.51465C6.55472 3.36521 6.75741 3.28125 6.96875 3.28125ZM7.76563 10.7188C7.48384 10.7188 7.21358 10.6068 7.01433 10.4076C6.81507 10.2083 6.70313 9.93804 6.70313 9.65625V7C6.56223 7 6.42711 6.94403 6.32748 6.8444C6.22785 6.74477 6.17188 6.60965 6.17188 6.46875C6.17188 6.32785 6.22785 6.19273 6.32748 6.0931C6.42711 5.99347 6.56223 5.9375 6.70313 5.9375C6.98492 5.9375 7.25517 6.04944 7.45443 6.2487C7.65369 6.44796 7.76563 6.71821 7.76563 7V9.65625C7.90652 9.65625 8.04165 9.71222 8.14128 9.81185C8.24091 9.91148 8.29688 10.0466 8.29688 10.1875C8.29688 10.3284 8.24091 10.4635 8.14128 10.5632C8.04165 10.6628 7.90652 10.7188 7.76563 10.7188Z"
                            fill="#666666"
                          />
                        </svg>
                      </div>
                    </TooltipTrigger>
                    <TooltipContent className="bg-black-label border-0">
                      <p className="bg-black-label text-white-A700">
                        {row?.original?.contactedBy?.length
                          ? row?.original?.contactedBy
                              ?.map((staff: any) => {
                                return staff;
                              })
                              .join(", ")
                          : "No staffs available"}
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider> */}
              </div>
            );
          }

          return newSource?.value ? (
            <div className="h-full flex flex-col gap-2">
              <div className="h-full w-[100px] flex gap-10">
                <p className="capitalize w-full whitespace-nowrap">
                  {newSource?.label}
                </p>
                <Img
                  className="text-right flex items-end h-5 w-5"
                  src={newSource?.icon}
                  alt="icon"
                />
              </div>
              {/* <p className="capitalize font-normal text-sm text-[#666666]">
                                {["outletID", "partnerOffice"].includes(
                                    row?.original?.channel as string,
                                )
                                    ? ""
                                    : row?.original?.channel}
                            </p> */}
              <p className="capitalize text-gray-500">
                {row?.original?.channelType}
              </p>
            </div>
          ) : (
            <p className="capitalize">{row?.original?.channelType}</p>
          );
        },
        filterFn: (row, id, value) => {
          return String(row.getValue(id))
            .toLowerCase()
            .includes(String(value).toLowerCase());
        },
        enableSorting: false,
      },
      {
        accessorKey: "note",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title="Note" />
        ),
        filterFn: (row, id, value) => {
          return String(row.getValue(id))
            .toLowerCase()
            .includes(String(value).toLowerCase());
        },
        cell: ({ row }) => {
          return (
            <div className="flex items-center justify-between gap-1.5">
              <p className="max-w-[200px] whitespace-normal break-words">
                {row.original.note}
              </p>
              {row.original.documents?.length > 0 &&
                row.original.documents.map((doc: any, index: number) => (
                  <button
                    key={index}
                    onClick={() => {
                      handleDownloadViaURL(doc.url, doc?.name);
                    }}
                    className="text-blue-500 hover:underline"
                  >
                    <svg
                      width="24"
                      height="23"
                      viewBox="0 0 24 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M21.2079 17.6048C21.2782 17.6751 21.3177 17.7705 21.3177 17.87C21.3177 17.9694 21.2782 18.0648 21.2079 18.1351L19.6156 19.7274C19.5453 19.7976 19.4499 19.837 19.3505 19.837C19.251 19.837 19.1557 19.7976 19.0853 19.7274L17.493 18.1351C17.4226 18.0648 17.3831 17.9694 17.3832 17.8699C17.3832 17.7704 17.4227 17.675 17.493 17.6047C17.5634 17.5344 17.6588 17.4949 17.7583 17.4949C17.8577 17.4949 17.9531 17.5345 18.0234 17.6048L18.9755 18.5568V15.5437C18.9755 15.4443 19.015 15.3489 19.0853 15.2786C19.1556 15.2082 19.251 15.1687 19.3505 15.1687C19.4499 15.1687 19.5453 15.2082 19.6156 15.2786C19.686 15.3489 19.7255 15.4443 19.7255 15.5437V18.5568L20.6776 17.6048C20.748 17.5346 20.8434 17.4952 20.9428 17.4952C21.0422 17.4952 21.1375 17.5346 21.2079 17.6048H21.2079ZM23.2213 17.9728C23.3457 16.9462 23.0573 15.9123 22.4195 15.0983C21.7817 14.2843 20.8468 13.757 19.8203 13.6322C19.6618 13.6129 19.5022 13.6031 19.3425 13.603C18.5917 13.6044 17.8572 13.8227 17.2274 14.2314C16.5975 14.6402 16.0991 15.2221 15.7919 15.9073C15.4848 16.5924 15.382 17.3517 15.4959 18.0939C15.6097 18.836 15.9355 19.5295 16.4339 20.0911C16.9324 20.6526 17.5824 21.0583 18.3058 21.2594C19.0292 21.4606 19.7953 21.4485 20.5121 21.2248C21.2288 21.0011 21.8658 20.5752 22.3463 19.9983C22.8269 19.4214 23.1307 18.718 23.2213 17.9726V17.9728ZM2.94998 19.515H15.1577C14.7973 18.7632 14.6456 17.9283 14.7185 17.0978C14.7914 16.2672 15.0862 15.4715 15.5721 14.794C16.058 14.1165 16.7171 13.5821 17.4804 13.2467C18.2437 12.9113 19.0832 12.7873 19.9109 12.8876C20.0698 12.9071 20.2277 12.9345 20.384 12.9697V10.0166L17.9141 7.54684L12.7912 11.24L14.3185 12.3106C14.3597 12.3385 14.3949 12.3743 14.4221 12.4159C14.4492 12.4576 14.4679 12.5042 14.4769 12.5532C14.4859 12.6021 14.485 12.6523 14.4744 12.7009C14.4638 12.7495 14.4437 12.7955 14.4151 12.8362C14.3866 12.8769 14.3502 12.9116 14.3081 12.9381C14.2661 12.9647 14.2191 12.9826 14.1701 12.9908C14.121 12.999 14.0708 12.9974 14.0224 12.986C13.974 12.9747 13.9283 12.9538 13.888 12.9246L6.19116 7.52931L0.754078 12.1268C0.752719 12.1279 0.751125 12.129 0.749766 12.1301V17.3145C0.750349 17.8978 0.982338 18.4572 1.39483 18.8697C1.80732 19.2822 2.36661 19.5142 2.94998 19.5149V19.515ZM2.94998 1.59747H18.1836C18.7669 1.59813 19.3261 1.83014 19.7386 2.24261C20.1511 2.65508 20.3831 3.21432 20.3838 3.79764V8.95623L18.2186 6.79117C18.1557 6.72819 18.0724 6.68967 17.9836 6.68249C17.8948 6.67532 17.8064 6.69997 17.7342 6.75203L12.141 10.7842L6.3847 6.74917C6.31685 6.70167 6.23519 6.67795 6.15244 6.68171C6.0697 6.68546 5.99052 6.71649 5.92725 6.76994L0.75 11.1482V3.79773C0.75067 3.21445 0.982662 2.65525 1.39509 2.24278C1.80752 1.83032 2.3667 1.59828 2.94998 1.59756V1.59747ZM23.01 14.6359C22.5188 14.0054 21.8723 13.5132 21.1337 13.2075V3.79773C21.1328 3.01559 20.8217 2.26575 20.2686 1.7127C19.7156 1.15964 18.9657 0.848549 18.1836 0.847656H2.94998C2.16787 0.848599 1.41807 1.15972 0.865039 1.71276C0.312011 2.26581 0.000917972 3.01562 0 3.79773L0 17.3147C0.0007446 18.0969 0.311806 18.8469 0.864916 19.4C1.41803 19.9531 2.16799 20.2642 2.95022 20.265H15.6112C15.6371 20.3007 15.6638 20.3358 15.6911 20.3705C16.4543 21.3329 17.5674 21.9542 18.7872 22.0986C20.007 22.2431 21.2343 21.8989 22.2012 21.1414C23.1681 20.3838 23.7958 19.2744 23.9474 18.0555C24.0989 16.8365 23.762 15.6072 23.01 14.6359ZM11.8242 4.26283C12.1642 4.26283 12.4966 4.36364 12.7792 4.55253C13.0619 4.74141 13.2823 5.00988 13.4124 5.32398C13.5425 5.63809 13.5765 5.98372 13.5102 6.31717C13.4439 6.65062 13.2802 6.95692 13.0398 7.19733C12.7993 7.43774 12.4931 7.60146 12.1596 7.66779C11.8262 7.73413 11.4805 7.70009 11.1664 7.56999C10.8523 7.43989 10.5838 7.21957 10.3949 6.93689C10.2061 6.65421 10.1052 6.32186 10.1052 5.98188C10.1058 5.52614 10.287 5.08922 10.6093 4.76696C10.9316 4.44471 11.3685 4.26344 11.8242 4.26292V4.26283ZM11.8242 8.45088C11.3359 8.45088 10.8585 8.30608 10.4524 8.03477C10.0464 7.76347 9.72992 7.37785 9.54303 6.92667C9.35615 6.4755 9.30725 5.97904 9.40252 5.50008C9.4978 5.02112 9.73296 4.58116 10.0783 4.23585C10.4236 3.89054 10.8636 3.65539 11.3425 3.56012C11.8215 3.46486 12.3179 3.51377 12.7691 3.70066C13.2203 3.88755 13.6059 4.20404 13.8772 4.61009C14.1485 5.01614 14.2933 5.49353 14.2933 5.98188C14.2925 6.63647 14.0321 7.26404 13.5693 7.7269C13.1064 8.18977 12.4788 8.45013 11.8242 8.45088Z"
                        fill="#165FE3"
                      />
                    </svg>
                  </button>
                ))}
              {row.original?.selfie && (
                <button
                  onClick={() => {
                    handleDownloadViaURL(row.original?.selfie, "selfie.jpg");
                  }}
                  className="text-blue-500 hover:underline"
                >
                  <svg
                    width="24"
                    height="23"
                    viewBox="0 0 24 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M21.2079 17.6048C21.2782 17.6751 21.3177 17.7705 21.3177 17.87C21.3177 17.9694 21.2782 18.0648 21.2079 18.1351L19.6156 19.7274C19.5453 19.7976 19.4499 19.837 19.3505 19.837C19.251 19.837 19.1557 19.7976 19.0853 19.7274L17.493 18.1351C17.4226 18.0648 17.3831 17.9694 17.3832 17.8699C17.3832 17.7704 17.4227 17.675 17.493 17.6047C17.5634 17.5344 17.6588 17.4949 17.7583 17.4949C17.8577 17.4949 17.9531 17.5345 18.0234 17.6048L18.9755 18.5568V15.5437C18.9755 15.4443 19.015 15.3489 19.0853 15.2786C19.1556 15.2082 19.251 15.1687 19.3505 15.1687C19.4499 15.1687 19.5453 15.2082 19.6156 15.2786C19.686 15.3489 19.7255 15.4443 19.7255 15.5437V18.5568L20.6776 17.6048C20.748 17.5346 20.8434 17.4952 20.9428 17.4952C21.0422 17.4952 21.1375 17.5346 21.2079 17.6048H21.2079ZM23.2213 17.9728C23.3457 16.9462 23.0573 15.9123 22.4195 15.0983C21.7817 14.2843 20.8468 13.757 19.8203 13.6322C19.6618 13.6129 19.5022 13.6031 19.3425 13.603C18.5917 13.6044 17.8572 13.8227 17.2274 14.2314C16.5975 14.6402 16.0991 15.2221 15.7919 15.9073C15.4848 16.5924 15.382 17.3517 15.4959 18.0939C15.6097 18.836 15.9355 19.5295 16.4339 20.0911C16.9324 20.6526 17.5824 21.0583 18.3058 21.2594C19.0292 21.4606 19.7953 21.4485 20.5121 21.2248C21.2288 21.0011 21.8658 20.5752 22.3463 19.9983C22.8269 19.4214 23.1307 18.718 23.2213 17.9726V17.9728ZM2.94998 19.515H15.1577C14.7973 18.7632 14.6456 17.9283 14.7185 17.0978C14.7914 16.2672 15.0862 15.4715 15.5721 14.794C16.058 14.1165 16.7171 13.5821 17.4804 13.2467C18.2437 12.9113 19.0832 12.7873 19.9109 12.8876C20.0698 12.9071 20.2277 12.9345 20.384 12.9697V10.0166L17.9141 7.54684L12.7912 11.24L14.3185 12.3106C14.3597 12.3385 14.3949 12.3743 14.4221 12.4159C14.4492 12.4576 14.4679 12.5042 14.4769 12.5532C14.4859 12.6021 14.485 12.6523 14.4744 12.7009C14.4638 12.7495 14.4437 12.7955 14.4151 12.8362C14.3866 12.8769 14.3502 12.9116 14.3081 12.9381C14.2661 12.9647 14.2191 12.9826 14.1701 12.9908C14.121 12.999 14.0708 12.9974 14.0224 12.986C13.974 12.9747 13.9283 12.9538 13.888 12.9246L6.19116 7.52931L0.754078 12.1268C0.752719 12.1279 0.751125 12.129 0.749766 12.1301V17.3145C0.750349 17.8978 0.982338 18.4572 1.39483 18.8697C1.80732 19.2822 2.36661 19.5142 2.94998 19.5149V19.515ZM2.94998 1.59747H18.1836C18.7669 1.59813 19.3261 1.83014 19.7386 2.24261C20.1511 2.65508 20.3831 3.21432 20.3838 3.79764V8.95623L18.2186 6.79117C18.1557 6.72819 18.0724 6.68967 17.9836 6.68249C17.8948 6.67532 17.8064 6.69997 17.7342 6.75203L12.141 10.7842L6.3847 6.74917C6.31685 6.70167 6.23519 6.67795 6.15244 6.68171C6.0697 6.68546 5.99052 6.71649 5.92725 6.76994L0.75 11.1482V3.79773C0.75067 3.21445 0.982662 2.65525 1.39509 2.24278C1.80752 1.83032 2.3667 1.59828 2.94998 1.59756V1.59747ZM23.01 14.6359C22.5188 14.0054 21.8723 13.5132 21.1337 13.2075V3.79773C21.1328 3.01559 20.8217 2.26575 20.2686 1.7127C19.7156 1.15964 18.9657 0.848549 18.1836 0.847656H2.94998C2.16787 0.848599 1.41807 1.15972 0.865039 1.71276C0.312011 2.26581 0.000917972 3.01562 0 3.79773L0 17.3147C0.0007446 18.0969 0.311806 18.8469 0.864916 19.4C1.41803 19.9531 2.16799 20.2642 2.95022 20.265H15.6112C15.6371 20.3007 15.6638 20.3358 15.6911 20.3705C16.4543 21.3329 17.5674 21.9542 18.7872 22.0986C20.007 22.2431 21.2343 21.8989 22.2012 21.1414C23.1681 20.3838 23.7958 19.2744 23.9474 18.0555C24.0989 16.8365 23.762 15.6072 23.01 14.6359ZM11.8242 4.26283C12.1642 4.26283 12.4966 4.36364 12.7792 4.55253C13.0619 4.74141 13.2823 5.00988 13.4124 5.32398C13.5425 5.63809 13.5765 5.98372 13.5102 6.31717C13.4439 6.65062 13.2802 6.95692 13.0398 7.19733C12.7993 7.43774 12.4931 7.60146 12.1596 7.66779C11.8262 7.73413 11.4805 7.70009 11.1664 7.56999C10.8523 7.43989 10.5838 7.21957 10.3949 6.93689C10.2061 6.65421 10.1052 6.32186 10.1052 5.98188C10.1058 5.52614 10.287 5.08922 10.6093 4.76696C10.9316 4.44471 11.3685 4.26344 11.8242 4.26292V4.26283ZM11.8242 8.45088C11.3359 8.45088 10.8585 8.30608 10.4524 8.03477C10.0464 7.76347 9.72992 7.37785 9.54303 6.92667C9.35615 6.4755 9.30725 5.97904 9.40252 5.50008C9.4978 5.02112 9.73296 4.58116 10.0783 4.23585C10.4236 3.89054 10.8636 3.65539 11.3425 3.56012C11.8215 3.46486 12.3179 3.51377 12.7691 3.70066C13.2203 3.88755 13.6059 4.20404 13.8772 4.61009C14.1485 5.01614 14.2933 5.49353 14.2933 5.98188C14.2925 6.63647 14.0321 7.26404 13.5693 7.7269C13.1064 8.18977 12.4788 8.45013 11.8242 8.45088Z"
                      fill="#165FE3"
                    />
                  </svg>
                </button>
              )}
            </div>
          );
        },
        enableSorting: false,
      },
    ],
    [handleUpdateInteractionStatus], // Add any other dependencies here
  );

  const opportunityCloseReason = [
    {
      value: "buyLater",
      label: "Buy Later",
    },
    {
      value: "notInterested",
      label: "Not Interested",
    },
    {
      value: "notServicable",
      label: " Not Serviceable",
    },
    {
      value: "spam",
      label: "Spam",
    },
    {
      value: "noResponse",
      label: "No Response",
    },
  ];

  const { mutate: mutateDigitalInterest, isLoading } = useDigitalMutation({
    refetch: getOpportunity as () => Promise<void>,
  });

  const handleUpdateDigitalInterest = async (value: string, label: string) => {
    mutateDigitalInterest({
      partner_id: Number(param?.id),
      digital_interest: label,
    });
  };

  const getStaffs = async () => {
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<GetAllStaffRequestType> = {
      headers: { Authorization: `Bearer ${authToken}` },
    };
    try {
      const res = (await getAllStaff(payload)) as any;
      const options = res.data.map((obj: any) => ({
        label: obj.fname,
        value: obj.id,
      }));
      setStaffs(options);
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  async function fetchRelationShipManager(): Promise<void | Option[]> {
    // get auth token from localstorage
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    const req = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    const name = localStorage.getItem("name");
    const is_owner = localStorage.getItem("is_owner");
    const owner_name = localStorage.getItem("owner_name");
    const myself = localStorage.getItem("staff_id");

    try {
      const res = await getRelationShipManager(req);

      const options = res.data.map((obj) => ({
        label: obj?.fname,
        value: obj?.id,
      }));

      const index = options.findIndex((item) => item?.value == myself);
      if (index > 0) {
        const item = options.splice(index, 1)[0];
        options.unshift(item);
      }

      return options as Option[];
    } catch (error) {
      toast.error("Error fetching options staff");
    }
  }

  const {
    options: relationShipManagerOptions,
    selectedOption: relationShipManagerSelectedOption,
    handleChange: relationShipManagerHandleChange,
  } = useSelectState(
    [],
    null,
    () => {},
    () => {},
    fetchRelationShipManager as () => Promise<Option[]>,
  );

  async function handleRequestDoc() {
    setLoading(true);
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    const req: AxiosRequestConfig<RequestDocReqType> = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      data: {
        opportunity_id: rowData?.id,
        exp_time: expires,
        channel,
        doc_list: selectedMode.map((mode) => ({ filename: mode })),
        note: popupnotes,
        channel_of_interaction_id: selectedChannelOption as string,
        interaction_note: interactionNote,
      },
    };

    try {
      const response = await requestDoc(req);
      if (response.status === 200) {
        toast.success("Documnet request sent successfully");
        setLoading(false);
        setInteractionNote("");
        setSelectedChannelOption("");
        setContactType("");
      }
    } catch (error) {
      toast.error("Unable to send document request");
      setLoading(false);
    }
  }

  const buttonState = () => {
    if (!interactionNote || !selectedChannelOption) return false;
    if (selectedChannelOption === "3") {
      if (!meetingTime || !selectedContact || !selectedStaffOptions.length)
        return false;
    }
    return true;
  };
  const { mutate } = useMutation({
    mutationFn: update_stage,
    onSuccess: (data) => {
      if (data.status === 200) {
        toast.success("Stage updated successfully");
        getOpportunity();
      } else {
        toast.error("Failed to update stage");
      }
    },
    onError: () => {
      toast.error("An error occurred while updating stage");
    },
  });
  const handleUpdateStage = (stage: string) => {
    mutate({
      opportunity_id: Number(param?.id),
      status: stage,
      type: "partner",
    });
  };
  useEffect(() => {
    const updateLeadStatus = async () => {
      if (selectedLeadStatus) {
        try {
          await changeLeadStatus({
            onSuccess: async () => {
              // Fetch the opportunity after successfully changing the lead status
              await getOpportunity();
            },
          });
        } catch (error) {
          console.error("Error in updating lead status:", error);
        }
      }
    };

    updateLeadStatus(); // Call the async function
  }, [selectedLeadStatus]); // This effect runs when selectedLeadStatus changes

  useEffect(() => {
    setInteractionNote("");
    setSelectedChannelOption("");
    setContactType("");
  }, []);

  useEffect(() => {
    getStaffs();
    fetchContactList();
  }, []);

  useEffect(() => {
    getOpportunity();
  }, [param?.id]);

  const navigate = useNavigate();

  const handlePrepareQuote = () => {
    if (opportunityDetails?.productSubcategory === "Remittance") {
      navigate("/L2CreateRemittanceQuotation", {
        state: {
          contact_name: contactDetails?.contactPerson,
          contact_number: contactDetails?.contactNumber,
          contact_email: contactDetails?.contactEmail,
          product_id: productDetails?.id,
          product_name: productDetails?.name,
          product_category: productDetails?.subCategory,
          opportunity_id: rowData?.id as string,
          remarks: "",
          meeting_time: date,
          meetingStaff_id: selectedStaffOptions?.map((staff) =>
            Number(staff.value),
          ),
          note: interactionNote,
          channel_of_interaction_id: selectedChannelOption as string,
        },
      });
    }
    if (opportunityDetails?.productSubcategory === "Forex") {
      navigate("/createforexquotation", {
        state: {
          contact_name: contactDetails?.contactPerson,
          contact_number: contactDetails?.contactNumber,
          contact_email: contactDetails?.contactEmail,
          product_id: productDetails?.id,
          opportunity_id: rowData?.id as string,
          remarks: "",
          meeting_time: date,
          meetingStaff_id: selectedStaffOptions?.map((staff) =>
            Number(staff.value),
          ),
          note: interactionNote,
          channel_of_interaction_id: selectedChannelOption as string,
        },
      });
    }
    return;
  };

  const handleSelect = (type: string, value: string) => {
    setSelectedChannel({ type, value });
    setSelectedType(null);
    setShowBothButtons(false);
  };

  function formatUnixTimestamp(unixTimestamp: number): string {
    // No need to multiply by 1000 since input is already in milliseconds
    const date = new Date(unixTimestamp);

    const day = date.getDate().toString().padStart(2, "0");

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "pm" : "am";

    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  }

  const formatDate = (unixTimestamp: number) => {
    if (!unixTimestamp) return "No date set";

    const date = new Date(unixTimestamp * 1000);

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    // Get hours in 12-hour format
    let hours = date.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Convert 0 to 12

    // Add leading zero to minutes if needed
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day} ${month} ${year} ${hours}:${minutes} ${ampm}`;
  };
  const generateSummary = async () => {
    setSummary("");
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const req: AxiosRequestConfig<GenerateSummaryReqType> = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      data: {
        lead_id: rowData?.id,
      },
    };

    try {
      const response = (await GenerateSummary(req)) as any;
      if (response.status === 200) {
        setSummary(response?.data?.response?.result?.summary);
      }
    } catch (error) {
      setSummary("Unable to generate summary");
    }
  };

  const opp_status = () => {
    const values = close_reason_options.find(
      (item) => item.value === opportunityDetails?.reasonToClose,
    );
    return (
      <p
        style={{ color: values?.textColor, backgroundColor: values?.bgColor }}
        className="py-[3px] px-2 rounded-md whitespace-nowrap"
      >
        {values?.label}
      </p>
    );
  };

  const handleResumeRegistration = async (e) => {
    e.stopPropagation();
    if (opportunityDetails?.isOpportunityOpen === "close") return;

    // Set resume form flag in Redux
    dispatch(setResumeForm(true));

    // Store channel ID in localStorage
    localStorage.setItem("child_channel_id", param?.id);

    // Store contact details in localStorage
    localStorage.setItem(
      "contact_details",
      JSON.stringify({
        email: contactDetails?.contactEmail,
        phone: contactDetails?.contactNumber,
        name: contactDetails?.contactPerson,
        city: contactDetails?.city,
      }),
    );

    // Get auth token
    const auth = localStorage.getItem("authToken");
    if (!auth) return;
    const authToken = JSON.parse(auth);

    // Use the correct API endpoint with getStep
    try {
      const response = await axios.get(
        `https://xxl6-bbr3-kxzs.m2.xano.io/api:EetDwnQJ/channels/getStep/${param?.id}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-type": "application/json",
            "X-Branch": `${import.meta.env.VITE_X_BRANCH}`,
            "X-Data-Source": `${import.meta.env.VITE_X_DATA_SOURCE}`,
          },
        },
      );

      // Navigate after successful API call
      navigate("/partnerregistration", {
        state: {
          partnerID: localStorage.getItem("child_channel_id"),
        },
      });
    } catch (error) {
      console.error(error);
      navigate("/partnerregistration", {
        state: {
          partnerID: localStorage.getItem("child_channel_id"),
        },
      });
    }
  };

  const handleSelectTab = (value: any) => {
    setActiveTab(value);
    setIsOpen(false);
  };

  const handleMobileFileChange = (file: File) => {
    if (!file.type.startsWith("image/")) {
      alert("Please upload only image files");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result as string;
      setPreviewUrl(base64);
      methods2.setValue("office_photo", base64, { shouldValidate: true });
    };
    reader.readAsDataURL(file);
  };

  const handleMobileViewClick = async (e) => {
    e.preventDefault();
    try {
      // Captured when the browser offers it, ignored when it does not:
      // nothing stores it, so it must not gate the submit.
      await requestLocation();
      if (selectedChannelOption === "3") {
        setISUploadScreen(true);
        setIsNextBtn(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const nextButtonState = () => {
    if (!interactionNote || !selectedChannelOption) return false;
    if (selectedChannelOption === "3") {
      if (!meetingTime || !selectedContact || !selectedStaffOptions.length)
        return false;
    }
    return true;
  };

  return (
    <div className="flex flex-col h-full bg-gray-100">
      {loading && <Spinner />}
      <div className=" gap-[10px] flex flex-col w-full overflow-auto">
        <div className="flex p-6 md:p-4 sm:p-2 lg:p-8 rounded-lg w-full bg-white-A700 justify-between">
          <div className="flex flex-col gap-1 w-full">
            {isMobile ? (
              <div className="mt-2 mb-2 rounded-lg">
                {/* Header */}
                <div className="space-y-2 w-full">
                  <div className="flex items-center justify-between w-full rounded-2xl border border-gray-200 px-4 py-2">
                    <div>
                      <span className="text-base font-semibold text-gray-900">
                        {contactDetails?.contactPerson}
                      </span>
                    </div>
                    <div className="flex flex-row items-baseline gap-3">
                      <Popover>
                        <PopoverTrigger className="disabled:opacity-50">
                          <button
                            onClick={() => setEditReminder(false)}
                            className="text-sm font-medium text-blue-700"
                          >
                            {extraDetails?.reminder_time ? (
                              <div className="relative">
                                {new Date(extraDetails?.followup_time) <=
                                  new Date() &&
                                  opportunityDetails?.isOpportunityOpen ===
                                    "open" && (
                                    <div className="absolute bottom-3 -right-1">
                                      <span className="animate-ping absolute inline-flex h-2 w-2 top-1.5 rounded-full bg-red-500 opacity-75"></span>
                                      <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                                    </div>
                                  )}
                                <svg
                                  width="19"
                                  height="20"
                                  viewBox="0 0 19 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4.88693 8.70306C5.04296 6.015 6.94433 3.53906 9.50273 3.53906C12.0612 3.53906 13.9625 6.015 14.1185 8.70306C14.1896 9.92548 14.3771 11.0978 14.9557 12.1706C15.5716 13.3124 15.0178 14.8737 13.7789 15.0274C12.354 15.2041 10.6857 15.3724 9.50273 15.3724C8.31982 15.3724 6.65148 15.2041 5.22655 15.0274C3.98773 14.8737 3.43383 13.3124 4.04975 12.1706C4.62843 11.0978 4.81596 9.92548 4.88693 8.70306Z"
                                    fill="#98BDFF"
                                  />
                                  <path
                                    d="M9.4974 17.7057C10.3719 17.7057 11.0807 16.9596 11.0807 16.0391C11.0807 16.0391 10.1205 16.2474 9.4974 16.2474C8.87428 16.2474 7.91406 16.0391 7.91406 16.0391C7.91406 16.9596 8.62292 17.7057 9.4974 17.7057Z"
                                    fill="#165FE3"
                                  />
                                  <path
                                    d="M9.5026 2.28906C9.06537 2.28906 8.71094 2.66216 8.71094 3.1224C8.71094 3.23153 8.73089 3.33575 8.76707 3.43128C8.76707 3.43128 9.21293 3.33073 9.5026 3.33073C9.79228 3.33073 10.2381 3.43128 10.2381 3.43128C10.2743 3.33575 10.2943 3.23153 10.2943 3.1224C10.2943 2.66216 9.93984 2.28906 9.5026 2.28906Z"
                                    fill="#165FE3"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M4.70144 2.87531C4.94313 3.1086 4.95938 3.50395 4.73775 3.75836C3.99278 4.6135 3.4453 5.66089 3.16992 6.82081C3.09042 7.15569 2.76806 7.35931 2.44993 7.27563C2.13179 7.19194 1.93835 6.85262 2.01786 6.51775C2.34239 5.15081 2.98717 3.91833 3.86254 2.91352C4.08417 2.65912 4.45976 2.642 4.70144 2.87531ZM14.6959 2.87531C14.9375 2.642 15.3131 2.65912 15.5347 2.91352C16.4102 3.91833 17.0549 5.15081 17.3795 6.51775C17.459 6.85262 17.2655 7.19194 16.9474 7.27563C16.6292 7.35931 16.3068 7.15569 16.2274 6.82081C15.952 5.66089 15.4045 4.6135 14.6595 3.75836C14.4379 3.50395 14.4542 3.1086 14.6959 2.87531Z"
                                    fill="#165FE3"
                                  />
                                </svg>
                              </div>
                            ) : (
                              <Bell className="h-5 w-5 text-gray-400" />
                            )}
                          </button>
                        </PopoverTrigger>
                        <PopoverContent
                          alignOffset={10}
                          align="start"
                          className="rounded-lg z-50 gap-4 p-2.5 flex flex-col"
                        >
                          {!extraDetails?.reminder_time || editReminder ? (
                            <>
                              <DateTimePicker date={date} setDate={setDate} />
                              <Input
                                type="text"
                                value={followupNote}
                                defaultValue={extraDetails?.followup_note}
                                onChange={(e) =>
                                  setFollowupNote(e.target.value)
                                }
                                placeholder="Note (if any)"
                                className="w-full placeholder:text-[#999999] border-0 h-5 border-b border-gray-200 p-0 rounded-none focus:border-b focus:border-blue-700 focus-visible:ring-0 focus-visible:ring-offset-0"
                              />
                              {date && (
                                <div className="flex gap-2.5 items-center">
                                  <PopoverClose asChild>
                                    <button
                                      onClick={() => {
                                        setDate(undefined);
                                        setFollowupNote("");
                                        setEditReminder(false);
                                      }}
                                      className="text-sm w-full font-medium text-blue-700 border border-blue-700 rounded-[4px] py-[8px] px-4"
                                    >
                                      Cancel
                                    </button>
                                  </PopoverClose>
                                  <button
                                    onClick={async () => {
                                      if (param?.id) {
                                        try {
                                          await handlePartnerUpdate(
                                            parseInt(param?.id),
                                            "",
                                            date,
                                            followupNote,
                                          );
                                        } catch (error) {
                                          console.error(
                                            "Error updating partner:",
                                            error,
                                          );
                                          // Optionally set an error state to inform the user
                                        }
                                      }
                                      setEditReminder(false);
                                      setIsClearReminder(false);
                                    }}
                                    className="text-sm w-full font-medium border border-blue-700 rounded-[4px] py-[8px] px-4 bg-blue-700 text-white-A700"
                                  >
                                    Save
                                  </button>
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="flex flex-col gap-2.5">
                              <div className="flex flex-col items-start border-b border-gray-200 pb-2.5">
                                <p className="text-sm font-medium text-[#999999] flex w-full justify-between items-center">
                                  Reminder set for
                                  <button
                                    onClick={() => {
                                      setEditReminder(true);
                                      setDate(
                                        new Date(extraDetails?.reminder_time),
                                      );
                                      setFollowupNote(
                                        extraDetails?.reminder_note,
                                      );
                                    }}
                                    className=""
                                  >
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M3.33594 4.74609H2.5026C2.06058 4.74609 1.63665 4.92169 1.32409 5.23425C1.01153 5.54681 0.835938 5.97073 0.835938 6.41276V13.9128C0.835938 14.3548 1.01153 14.7787 1.32409 15.0913C1.63665 15.4038 2.06058 15.5794 2.5026 15.5794H10.0026C10.4446 15.5794 10.8686 15.4038 11.1811 15.0913C11.4937 14.7787 11.6693 14.3548 11.6693 13.9128V13.0794"
                                        stroke="#165FE3"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M10.8333 3.08472L13.3333 5.58472M14.4875 4.40556C14.8157 4.07735 15.0001 3.63221 15.0001 3.16806C15.0001 2.70391 14.8157 2.25876 14.4875 1.93056C14.1593 1.60235 13.7142 1.41797 13.25 1.41797C12.7858 1.41797 12.3407 1.60235 12.0125 1.93056L5 8.91806V11.4181H7.5L14.4875 4.40556Z"
                                        stroke="#165FE3"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </button>
                                </p>
                                <p className="">
                                  {formatUnixTimestamp(
                                    extraDetails?.reminder_time,
                                  )}
                                </p>
                              </div>

                              {!isClearReminder && (
                                <p className="text-sm font-medium text-[#999999]">
                                  {extraDetails?.reminder_note}
                                </p>
                              )}
                              {!isClearReminder && (
                                <button
                                  onClick={() => {
                                    (setDate(undefined),
                                      setIsClearReminder(true));
                                  }}
                                  className="text-sm w-full text-right font-medium text-blue-700 underline underline-offset-4"
                                >
                                  Clear Reminder
                                </button>
                              )}
                              {isClearReminder && (
                                <div className="flex flex-col gap-2.5 items-center w-full">
                                  <p className="">
                                    You will not be notified for a follow up.
                                    Are you sure you want to remove the reminder
                                    on this lead?
                                  </p>
                                  <div className="flex gap-2.5 items-center w-full">
                                    <button
                                      onClick={() => {
                                        clearReminder({
                                          onSuccess: getOpportunity,
                                          setLoading,
                                        });
                                      }}
                                      className="text-sm w-full font-medium text-blue-700 border border-blue-700 rounded-[4px] py-[8px] px-4"
                                    >
                                      Yes
                                    </button>
                                    <button
                                      onClick={() => setIsClearReminder(false)}
                                      className="text-sm w-full font-medium border border-blue-700 rounded-[4px] py-[8px] px-4 bg-blue-700 text-white-A700"
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </PopoverContent>
                      </Popover>
                      <Popover
                        onOpenChange={async (val) => {
                          if (val) {
                            await generateSummary();
                          }
                        }}
                      >
                        <PopoverTrigger>
                          <div className="flex items-center cursor-pointer">
                            <button
                              className="text-blue-700 opacity-50 cursor-not-allowed text-base leading-4 font-semibold bg-[#E1EBFC99] px-2 py-1.5 rounded-lg w-[81px] h-[28px] flex items-center justify-center"
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              Summary
                            </button>
                            <div className="relative bottom-1 ">
                              <svg
                                width="14"
                                height="16"
                                viewBox="0 0 14 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.6102 10.9659L10.6101 10.9655C10.6087 10.9616 10.6067 10.9596 10.6049 10.9583C10.6027 10.9569 10.5997 10.9559 10.5962 10.9559C10.5927 10.9559 10.5896 10.9569 10.5873 10.9584C10.5853 10.9597 10.5833 10.9618 10.5818 10.9659H10.6102ZM10.6102 10.9659L10.8389 11.6002L10.8389 11.6003C10.9669 11.955 11.1714 12.2771 11.4381 12.5437C11.7047 12.8104 12.0268 13.015 12.3815 13.1429L12.3816 13.1429L13.0158 13.3716C13.0158 13.3716 13.0158 13.3716 13.0159 13.3716C13.0187 13.3727 13.0212 13.3746 13.023 13.3771L13.064 13.3485L13.023 13.3771C13.0248 13.3797 13.0257 13.3827 13.0257 13.3858C13.0257 13.389 13.0248 13.392 13.023 13.3946L13.064 13.4232L13.023 13.3946C13.0212 13.3971 13.0187 13.399 13.0159 13.4001C13.0158 13.4001 13.0158 13.4001 13.0158 13.4001L12.3816 13.6287L12.3815 13.6288C12.0268 13.7567 11.7047 13.9613 11.4381 14.2279C11.1714 14.4946 10.9669 14.8167 10.8389 15.1714L10.8389 15.1715L10.6103 15.8057C10.6103 15.8057 10.6102 15.8057 10.6102 15.8057C10.6092 15.8086 10.6072 15.8111 10.6047 15.8129C10.6022 15.8147 10.5991 15.8157 10.596 15.8157C10.5929 15.8157 10.5898 15.8147 10.5873 15.8129C10.5848 15.8111 10.5828 15.8086 10.5818 15.8057C10.5818 15.8057 10.5817 15.8057 10.5817 15.8057L10.3531 15.1715L10.3531 15.1714C10.2251 14.8167 10.0206 14.4946 9.75393 14.2279C9.48729 13.9613 9.16516 13.7567 8.81046 13.6288L8.81045 13.6287L8.17624 13.4001C8.17621 13.4001 8.17617 13.4001 8.17614 13.4001C8.17325 13.399 8.17076 13.3971 8.169 13.3946C8.16721 13.392 8.16625 13.389 8.16625 13.3858C8.16625 13.3827 8.16721 13.3797 8.169 13.3771C8.17076 13.3746 8.17325 13.3727 8.17614 13.3716C8.17617 13.3716 8.17621 13.3716 8.17624 13.3716L8.81045 13.1429L8.81046 13.1429C9.16516 13.015 9.48729 12.8104 9.75393 12.5437C10.0206 12.2771 10.2251 11.955 10.3531 11.6003L10.3531 11.6002L10.5818 10.966L10.6102 10.9659ZM10.6572 10.9489L10.8859 11.5833C11.0114 11.9311 11.212 12.2469 11.4734 12.5084C11.7349 12.7698 12.0507 12.9704 12.3985 13.0959L10.6572 10.9489ZM10.6572 10.9489C10.637 10.8916 10.5555 10.8916 10.5348 10.9489H10.6572ZM4.96995 3.20353L4.97006 3.20383L5.42125 4.45685L5.42126 4.45687C5.67132 5.15071 6.07136 5.78084 6.59285 6.30235C7.11435 6.82387 7.74447 7.22392 8.43829 7.47399L8.4383 7.47399L9.69102 7.92509C9.69107 7.92511 9.69112 7.92513 9.69117 7.92515C9.70623 7.93071 9.71924 7.94075 9.72843 7.95391C9.73765 7.96712 9.7426 7.98285 9.7426 7.99896C9.7426 8.01507 9.73765 8.0308 9.72843 8.04401C9.71923 8.05717 9.70623 8.06721 9.69117 8.07277C9.69112 8.07278 9.69107 8.0728 9.69102 8.07282L8.4383 8.52392L8.43829 8.52393C7.74447 8.774 7.11435 9.17405 6.59285 9.69556C6.07136 10.2171 5.67132 10.8472 5.42126 11.541L5.42125 11.5411L4.97016 12.7938C4.97014 12.7939 4.97013 12.7939 4.97011 12.794C4.96455 12.809 4.95451 12.822 4.94135 12.8312C4.92814 12.8405 4.91241 12.8454 4.8963 12.8454C4.88019 12.8454 4.86447 12.8405 4.85126 12.8312C4.83809 12.822 4.82805 12.809 4.82249 12.794C4.82248 12.7939 4.82246 12.7939 4.82244 12.7938L4.37135 11.5411L4.37135 11.541C4.12128 10.8472 3.72125 10.2171 3.19975 9.69556C2.67825 9.17405 2.04814 8.774 1.35431 8.52393L1.3543 8.52392L0.101586 8.07282C0.101554 8.07281 0.101523 8.0728 0.101491 8.07279C0.0864045 8.06723 0.0733802 8.05719 0.0641733 8.04401C0.0549475 8.0308 0.05 8.01507 0.05 7.99896C0.05 7.98285 0.0549475 7.96712 0.0641733 7.95391C0.0733802 7.94073 0.0864043 7.93068 0.101492 7.92513C0.101523 7.92512 0.101554 7.92511 0.101586 7.92509L1.3543 7.47399L1.35431 7.47399C2.04814 7.22392 2.67825 6.82387 3.19975 6.30235C3.72125 5.78084 4.12128 5.15071 4.37135 4.45687L4.37135 4.45685L4.82254 3.20383L4.82265 3.20353C4.82803 3.18829 4.838 3.1751 4.85119 3.16576C4.86438 3.15643 4.88014 3.15142 4.8963 3.15142C4.91246 3.15142 4.92822 3.15643 4.94141 3.16576C4.95461 3.1751 4.96458 3.18829 4.96995 3.20353ZM10.8389 0.827029L10.8389 0.82704C10.9669 1.18175 11.1714 1.50389 11.4381 1.77053C11.7047 2.03717 12.0268 2.24176 12.3815 2.36973L12.3816 2.36973L13.0158 2.59837C13.0158 2.59838 13.0158 2.59838 13.0158 2.59839C13.0187 2.59946 13.0212 2.60139 13.023 2.60392L13.064 2.57525L13.023 2.60393C13.0248 2.60648 13.0257 2.60952 13.0257 2.61263C13.0257 2.61575 13.0248 2.61879 13.023 2.62134L13.064 2.65001L13.023 2.62134C13.0212 2.62387 13.0187 2.6258 13.0158 2.62687C13.0158 2.62688 13.0158 2.62689 13.0158 2.6269L12.3816 2.85553L12.3815 2.85554C12.0268 2.98351 11.7047 3.18809 11.4381 3.45473C11.1714 3.72137 10.9669 4.04351 10.8389 4.39822L10.8389 4.39824L10.6103 5.03247C10.6103 5.03249 10.6102 5.03252 10.6102 5.03255C10.6092 5.03544 10.6072 5.03794 10.6047 5.03971C10.6022 5.04149 10.5991 5.04245 10.596 5.04245C10.5929 5.04245 10.5898 5.04149 10.5873 5.03971C10.5848 5.03794 10.5828 5.03544 10.5818 5.03255C10.5818 5.03252 10.5817 5.03249 10.5817 5.03247L10.3531 4.39824L10.3531 4.39822C10.2251 4.04351 10.0206 3.72137 9.75393 3.45473C9.48729 3.18809 9.16516 2.98351 8.81046 2.85554L8.81045 2.85553L8.17624 2.6269C8.17621 2.62689 8.17619 2.62688 8.17616 2.62687C8.17327 2.6258 8.17077 2.62387 8.169 2.62134C8.16721 2.61879 8.16625 2.61575 8.16625 2.61263C8.16625 2.60952 8.16721 2.60648 8.169 2.60392C8.17077 2.60139 8.17328 2.59946 8.17618 2.59839C8.1762 2.59838 8.17622 2.59838 8.17624 2.59837L8.81045 2.36973L8.81046 2.36973C9.16516 2.24176 9.48729 2.03717 9.75393 1.77053C10.0206 1.50389 10.2251 1.18175 10.3531 0.82704L10.3531 0.827029L10.5817 0.192798C10.5817 0.192774 10.5818 0.19275 10.5818 0.192726C10.5828 0.189832 10.5848 0.187329 10.5873 0.185556C10.5898 0.18377 10.5929 0.182813 10.596 0.182813C10.5991 0.182813 10.6022 0.183771 10.6047 0.185556L10.6047 0.185558C10.6072 0.187329 10.6092 0.189829 10.6102 0.192725C10.6102 0.192749 10.6103 0.192774 10.6103 0.192798L10.8389 0.827029Z"
                                  fill="#AAC8FF"
                                  stroke="#A2A2A2"
                                  strokeWidth="0.1"
                                />
                              </svg>
                            </div>
                          </div>
                        </PopoverTrigger>
                        <PopoverContent
                          alignOffset={10}
                          align="end"
                          className="rounded-lg z-50 gap-2.5 p-4 w-[280px] sm:w-[350px] md:w-[450px] flex flex-col lg:w-[590px]"
                        >
                          <div className="flex items-center justify-between w-full">
                            <p className="font-normal text-xs text-[#999999] leading-[18px]">
                              Generated on {formatDate(Date.now().toString())}
                            </p>
                            <button
                              onClick={() => {
                                navigator.clipboard.writeText(summary);
                                toast.success("Copied to clipboard");
                              }}
                            >
                              <svg
                                width="13"
                                height="16"
                                viewBox="0 0 13 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9.93685 4.31075L9.93685 4.31028C9.93352 3.60136 9.35783 3.025 8.65111 3.025H1.67793C0.968395 3.025 0.392187 3.60121 0.392187 4.31075V14.3159C0.392187 15.0254 0.968395 15.6016 1.67793 15.6016H8.65111C9.36065 15.6016 9.93685 15.0254 9.93685 14.3159L9.93685 4.31075ZM8.90437 14.3128C8.90437 14.4542 8.78941 14.5691 8.64803 14.5691H1.67486C1.53349 14.5691 1.41852 14.4542 1.41852 14.3128V4.31075C1.41852 4.16937 1.53349 4.05441 1.67486 4.05441H8.64803C8.78941 4.05441 8.90437 4.16937 8.90437 4.31075V14.3128Z"
                                  fill="#165FE3"
                                  stroke="#165FE3"
                                  strokeWidth="0.2"
                                />
                                <path
                                  d="M11.3152 0.4H4.342C3.63246 0.4 3.05625 0.976207 3.05625 1.68575C3.05625 1.97137 3.28533 2.20045 3.57095 2.20045C3.85657 2.20045 4.08566 1.97137 4.08566 1.68575C4.08566 1.54437 4.20062 1.42941 4.342 1.42941H11.3152C11.4565 1.42941 11.5715 1.54437 11.5715 1.68575V11.6909C11.5715 11.8322 11.4565 11.9472 11.3152 11.9472C11.0295 11.9472 10.8005 12.1763 10.8005 12.4619C10.8005 12.7475 11.0295 12.9766 11.3152 12.9766C12.0247 12.9766 12.6009 12.4004 12.6009 11.6909V1.68575C12.6009 0.976207 12.0247 0.4 11.3152 0.4Z"
                                  fill="#165FE3"
                                  stroke="#165FE3"
                                  strokeWidth="0.2"
                                />
                              </svg>
                            </button>
                          </div>
                          <p className="font-normal text-sm text-black-label leading-[21px]">
                            {summary || (
                              <div className="space-y-2">
                                <Skeleton className="h-4 bg-gray-600 w-full rounded-full" />
                                <Skeleton className="h-4 bg-gray-600 w-full rounded-full" />
                                <Skeleton className="h-4 bg-gray-600 w-full rounded-full" />
                              </div>
                            )}
                          </p>
                        </PopoverContent>
                      </Popover>
                    </div>
                  </div>

                  {/* Partner Info Row */}
                  <div
                    className="flex items-center justify-between w-full bg-gray-50 px-3 py-2 rounded-md"
                    onClick={() => setPersonalInfoTabOpen((v) => !v)}
                  >
                    <span className="text-base text-gray-400">
                      Partner full Information
                    </span>
                    {personalInfoTabOpen ? (
                      <ChevronUp className="h-5 w-5 text-gray-600" />
                    ) : (
                      <ChevronDown className="h-5 w-5 text-gray-600" />
                    )}
                  </div>
                </div>

                {/* Content – only show if open */}
                {personalInfoTabOpen && (
                  <div className="flex flex-col gap-4 px-3 py-4">
                    {/* Info badges */}
                    <div className="flex flex-wrap gap-2">
                      <span className="px-2 py-1 text-xs bg-gray-100 rounded-lg">
                        {contactDetails?.type}
                      </span>
                      {extraDetails?.services?.length > 0 && (
                        <div>
                          <span className="font-normal px-2 text-xs leading-6 text-[#666666]">
                            {extraDetails.services.map((service, index) => (
                              <span key={index}>
                                {service.charAt(0).toUpperCase() +
                                  service.slice(1)}
                                {index < extraDetails.services.length - 1 && (
                                  <span className="text-[#DDDDDD] h-1.5 w-1.5">
                                    {" "}
                                    ·{" "}
                                  </span>
                                )}
                              </span>
                            ))}
                          </span>
                        </div>
                      )}
                    </div>

                    {/* Contact */}
                    <div className="flex items-center mb-1">
                      <p className="text-[#333333] text-sm font-normal leading-[21px] flex flex-col gap-2">
                        {primaryContact?.contactName ? (
                          <div className="flex items-center gap-2">
                            <svg
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0_3080_71727)">
                                <rect
                                  y="0.5"
                                  width="20"
                                  height="20"
                                  rx="10"
                                  fill="#F1F1F1"
                                />
                                <path
                                  d="M7.14834 11.2066C7.30318 12.2131 8.08095 13.4941 9.35845 13.9446C9.88282 14.1276 10.4565 14.1311 10.9808 13.9411C12.2372 13.4871 13.0396 12.2096 13.198 11.2066C13.3669 11.1925 13.5886 10.9567 13.8279 10.1086C14.1552 8.95071 13.8068 8.77827 13.5112 8.80642C13.5675 8.64805 13.6097 8.48617 13.6379 8.33132C14.1376 5.32937 12.6595 5.22731 12.6595 5.22731C12.6595 5.22731 12.4132 4.75572 11.7692 4.40027C11.3363 4.14337 10.7345 3.94629 9.94265 4.01315C9.68574 4.02371 9.44291 4.0765 9.21416 4.15041C8.92206 4.24895 8.65459 4.39324 8.41176 4.56216C8.11614 4.74868 7.8346 4.98096 7.58825 5.2449C7.19761 5.6461 6.8492 6.16344 6.69787 6.80747C6.57117 7.28961 6.59933 7.79287 6.70491 8.33484C6.73306 8.4932 6.77529 8.65157 6.8316 8.80994C6.53598 8.78179 6.18757 8.95423 6.51486 10.1121C6.75769 10.9567 6.97941 11.1925 7.14834 11.2066Z"
                                  fill="#333333"
                                />
                                <path
                                  d="M15.9737 15.1453C14.1754 14.6878 12.7148 13.6602 12.7148 13.6602L11.5746 17.2674L11.3599 17.9467L11.3564 17.9361L11.1699 18.5133L10.5681 16.8064C12.0462 14.7441 10.2689 14.7652 10.1704 14.7687C10.0719 14.7652 8.29462 14.7441 9.77272 16.8064L9.17093 18.5133L8.9844 17.9361L8.98088 17.9467L8.76621 17.2674L7.62244 13.6602C7.62244 13.6602 6.16194 14.6878 4.36358 15.1453C3.02273 15.4867 2.95938 17.0352 3.01217 17.7988C3.01217 17.7988 3.0896 18.837 3.16702 19.2945C3.16702 19.2945 5.78537 20.9944 10.1704 20.9979C14.5554 20.9979 17.1738 19.2945 17.1738 19.2945C17.2512 18.837 17.3286 17.7988 17.3286 17.7988C17.3779 17.0352 17.3146 15.4867 15.9737 15.1453Z"
                                  fill="#333333"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_3080_71727">
                                  <rect
                                    y="0.5"
                                    width="20"
                                    height="20"
                                    rx="10"
                                    fill="white"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                            {primaryContact?.contactName}
                          </div>
                        ) : (
                          <span className="text-[#999999]">
                            No contact linked yet
                          </span>
                        )}

                        <div className="flex items-center gap-2">
                          {primaryContact?.contactNumber && (
                            <span>{primaryContact.contactNumber}</span>
                          )}
                          {primaryContact?.contactNumber &&
                            primaryContact?.contactEmail && (
                              <span className="text-gray-300">|</span>
                            )}
                          {primaryContact?.contactEmail && (
                            <span>{primaryContact.contactEmail}</span>
                          )}
                        </div>
                      </p>
                    </div>
                    <div className="text-xs text-gray-400">
                      {contactDetails?.createDate}
                      {contactDetails?._created_by?.fname &&
                        ` by ${contactDetails._created_by.fname}`}
                    </div>

                    {/* Footer actions */}
                    <div className="flex items-center justify-between">
                      <div className="flex gap-2.5 items-center text-sm">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.835 19.67C15.2667 19.67 19.67 15.2667 19.67 9.835C19.67 4.40328 15.2667 0 9.835 0C4.40328 0 0 4.40328 0 9.835C0 15.2667 4.40328 19.67 9.835 19.67Z"
                            fill="#F1F1F1"
                          />
                          <path
                            d="M9.83656 4.85938C7.80072 4.85938 6.14844 6.51165 6.14844 8.5475C6.14844 10.544 7.7122 12.1668 9.78739 12.2258C9.81689 12.2258 9.85623 12.2258 9.8759 12.2258C9.89557 12.2258 9.92508 12.2258 9.94475 12.2258C9.95458 12.2258 9.96442 12.2258 9.96442 12.2258C11.9511 12.1569 13.5149 10.544 13.5247 8.5475C13.5247 6.51165 11.8724 4.85938 9.83656 4.85938Z"
                            fill="#333333"
                          />
                          <path
                            d="M16.5081 17.0582C14.7575 18.6711 12.4168 19.6645 9.84001 19.6645C7.26324 19.6645 4.92251 18.6711 3.17188 17.0582C3.40791 16.1632 4.04719 15.3469 4.98152 14.7175C7.66647 12.9275 12.0332 12.9275 14.6985 14.7175C15.6427 15.3469 16.2721 16.1632 16.5081 17.0582Z"
                            fill="#333333"
                          />
                        </svg>{" "}
                        <span>{contactDetails?._rm?.fname}</span>
                        <span className="ml-1 text-gray-500">New Delhi</span>
                      </div>
                      {/* <button className="text-blue-600 text-sm font-medium hover:underline">
                        Reassign
                      </button> */}
                      <div className="">
                        <AlertDialog
                          onOpenChange={(open) => {
                            if (open)
                              relationShipManagerHandleChange(
                                relationShipManagerOptions?.find(
                                  (option) =>
                                    option?.value === contactDetails?._rm?.id,
                                ) as SingleValue<Option>,
                              );
                            // Handle any side effects when dialog opens/closes
                          }}
                        >
                          <AlertDialogTrigger asChild>
                            <div className="text-sm font-semibold text-blue-700 cursor-pointer hover:underline">
                              Reassign
                            </div>
                          </AlertDialogTrigger>
                          <AlertDialogPortal>
                            <AlertDialogOverlay className="  bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
                            <AlertDialogContent className="bg-white-A700 rounded-lg p-0 w-full animate-contentShow">
                              <AlertDialogHeader className="flex text-left border-b  rounded-t py-3 px-10 ">
                                <AlertDialogTitle className="font-bold p-0 text-lg text-black-label">
                                  Select the staff to assign
                                </AlertDialogTitle>
                                <AlertDialogDescription></AlertDialogDescription>
                              </AlertDialogHeader>
                              <form className="px-10 w-full flex py-3 flex-col gap-2">
                                <label
                                  htmlFor="staff_select"
                                  className=" text-sm font-medium "
                                >
                                  Choose a staff
                                </label>
                                <ReactSelect
                                  menuPlacement="auto"
                                  className=""
                                  menuPosition="absolute"
                                  placeholder="Select the staff"
                                  styles={{
                                    control: (provided, state) => ({
                                      ...provided,
                                      zIndex: 0,
                                      borderRadius: ".5rem",
                                      padding: ".4rem",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderColor: state.isFocused
                                        ? "#165FE3"
                                        : "#333333",
                                      boxShadow: "none",
                                    }),
                                    menu: (provided, state) => ({
                                      ...provided,
                                      zIndex: 1000,
                                    }),
                                  }}
                                  options={relationShipManagerOptions}
                                  onChange={relationShipManagerHandleChange}
                                  value={relationShipManagerSelectedOption}
                                  name="staff_select"
                                  id="staff_select"
                                />
                              </form>
                              <AlertDialogFooter className="flex justify-start items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
                                <AlertDialogCancel
                                  className=" m-0 rounded-lg border-blue-700 border py-[11px] px-4 text-blue-700"
                                  asChild
                                >
                                  <button>Cancel</button>
                                </AlertDialogCancel>
                                <AlertDialogAction
                                  className="rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700"
                                  asChild
                                >
                                  <button
                                    className="disabled:opacity-50"
                                    disabled={
                                      loading ||
                                      !relationShipManagerSelectedOption
                                    }
                                    onClick={() =>
                                      handlePartnerUpdate(
                                        parseInt(param?.id),
                                        relationShipManagerSelectedOption?.value,
                                        "",
                                        "",
                                      )
                                    }
                                  >
                                    {loading ? "Reassigning..." : "Submit"}
                                  </button>
                                </AlertDialogAction>
                              </AlertDialogFooter>
                            </AlertDialogContent>
                          </AlertDialogPortal>
                        </AlertDialog>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="flex gap-2 sm:flex-col">
                <div className="flex items-start gap-2">
                  <div className="flex flex-col">
                    <div className="flex items-center gap-2">
                      <h4 className="text-xl leading-[30px] capitalize text-black-label font-semibold">
                        {contactDetails?.contactPerson}
                      </h4>
                      <div className="flex items-center gap-2">
                        <p className="text-sm leading-[16.8px] px-4 py-1 capitalize text-[#333333] rounded-[4px] bg-[#F1F1F1] font-normal">
                          {contactDetails?.type}
                        </p>
                      </div>
                      {extraDetails?.services?.length > 0 && (
                        <div>
                          <span className="font-normal text-base leading-6 text-[#666666]">
                            {extraDetails.services.map((service, index) => (
                              <span key={index}>
                                {service.charAt(0).toUpperCase() +
                                  service.slice(1)}
                                {index < extraDetails.services.length - 1 && (
                                  <span className="text-[#DDDDDD] h-1.5 w-1.5">
                                    {" "}
                                    ·{" "}
                                  </span>
                                )}
                              </span>
                            ))}
                          </span>
                        </div>
                      )}
                    </div>
                    <p className="text-sm leading-[21px]  mt-1 font-normal">
                      <div className="flex items-center border-b-2 pb-[10px] justify-start gap-4 text-[#999999]">
                        ID-{param.id} |{" "}
                        <p className="text-[#333333] text-sm font-normal leading-[21px] flex items-center">
                          {primaryContact?.contactName ? (
                            <div className="flex flex-row items-center mr-1 gap-2">
                              <svg
                                width="20"
                                height="21"
                                viewBox="0 0 20 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_3080_71727)">
                                  <rect
                                    y="0.5"
                                    width="20"
                                    height="20"
                                    rx="10"
                                    fill="#F1F1F1"
                                  />
                                  <path
                                    d="M7.14834 11.2066C7.30318 12.2131 8.08095 13.4941 9.35845 13.9446C9.88282 14.1276 10.4565 14.1311 10.9808 13.9411C12.2372 13.4871 13.0396 12.2096 13.198 11.2066C13.3669 11.1925 13.5886 10.9567 13.8279 10.1086C14.1552 8.95071 13.8068 8.77827 13.5112 8.80642C13.5675 8.64805 13.6097 8.48617 13.6379 8.33132C14.1376 5.32937 12.6595 5.22731 12.6595 5.22731C12.6595 5.22731 12.4132 4.75572 11.7692 4.40027C11.3363 4.14337 10.7345 3.94629 9.94265 4.01315C9.68574 4.02371 9.44291 4.0765 9.21416 4.15041C8.92206 4.24895 8.65459 4.39324 8.41176 4.56216C8.11614 4.74868 7.8346 4.98096 7.58825 5.2449C7.19761 5.6461 6.8492 6.16344 6.69787 6.80747C6.57117 7.28961 6.59933 7.79287 6.70491 8.33484C6.73306 8.4932 6.77529 8.65157 6.8316 8.80994C6.53598 8.78179 6.18757 8.95423 6.51486 10.1121C6.75769 10.9567 6.97941 11.1925 7.14834 11.2066Z"
                                    fill="#333333"
                                  />
                                  <path
                                    d="M15.9737 15.1453C14.1754 14.6878 12.7148 13.6602 12.7148 13.6602L11.5746 17.2674L11.3599 17.9467L11.3564 17.9361L11.1699 18.5133L10.5681 16.8064C12.0462 14.7441 10.2689 14.7652 10.1704 14.7687C10.0719 14.7652 8.29462 14.7441 9.77272 16.8064L9.17093 18.5133L8.9844 17.9361L8.98088 17.9467L8.76621 17.2674L7.62244 13.6602C7.62244 13.6602 6.16194 14.6878 4.36358 15.1453C3.02273 15.4867 2.95938 17.0352 3.01217 17.7988C3.01217 17.7988 3.0896 18.837 3.16702 19.2945C3.16702 19.2945 5.78537 20.9944 10.1704 20.9979C14.5554 20.9979 17.1738 19.2945 17.1738 19.2945C17.2512 18.837 17.3286 17.7988 17.3286 17.7988C17.3779 17.0352 17.3146 15.4867 15.9737 15.1453Z"
                                    fill="#333333"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_3080_71727">
                                    <rect
                                      y="0.5"
                                      width="20"
                                      height="20"
                                      rx="10"
                                      fill="white"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              {primaryContact?.contactName}{" "}
                            </div>
                          ) : (
                            <span className="text-[#999999]">
                              No contact linked yet
                            </span>
                          )}
                          {primaryContact?.contactNumber && (
                            <> | {primaryContact.contactNumber}</>
                          )}
                          {primaryContact?.contactEmail && (
                            <> | {primaryContact.contactEmail}</>
                          )}
                        </p>
                      </div>
                    </p>
                    <p className="text-[#C4C4C4] mt-[10px]">
                      {contactDetails?.createDate}
                      {contactDetails?._created_by?.fname &&
                        ` by ${contactDetails._created_by.fname}`}
                    </p>
                  </div>
                </div>
                <div className="flex-1 w-full flex flex-col h-full justify-between">
                  <div className="flex relative justify-end gap-2.5">
                    <div className="flex items-center gap-6 ">
                      <Popover>
                        <PopoverTrigger className="disabled:opacity-50">
                          <button
                            onClick={() => setEditReminder(false)}
                            className="text-sm font-medium text-blue-700"
                          >
                            {extraDetails?.reminder_time ? (
                              <div className="relative">
                                {new Date(extraDetails?.followup_time) <=
                                  new Date() &&
                                  opportunityDetails?.isOpportunityOpen ===
                                    "open" && (
                                    <div className="absolute bottom-3 -right-1">
                                      <span className="animate-ping absolute inline-flex h-2 w-2 top-1.5 rounded-full bg-red-500 opacity-75"></span>
                                      <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                                    </div>
                                  )}
                                <svg
                                  width="19"
                                  height="20"
                                  viewBox="0 0 19 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4.88693 8.70306C5.04296 6.015 6.94433 3.53906 9.50273 3.53906C12.0612 3.53906 13.9625 6.015 14.1185 8.70306C14.1896 9.92548 14.3771 11.0978 14.9557 12.1706C15.5716 13.3124 15.0178 14.8737 13.7789 15.0274C12.354 15.2041 10.6857 15.3724 9.50273 15.3724C8.31982 15.3724 6.65148 15.2041 5.22655 15.0274C3.98773 14.8737 3.43383 13.3124 4.04975 12.1706C4.62843 11.0978 4.81596 9.92548 4.88693 8.70306Z"
                                    fill="#98BDFF"
                                  />
                                  <path
                                    d="M9.4974 17.7057C10.3719 17.7057 11.0807 16.9596 11.0807 16.0391C11.0807 16.0391 10.1205 16.2474 9.4974 16.2474C8.87428 16.2474 7.91406 16.0391 7.91406 16.0391C7.91406 16.9596 8.62292 17.7057 9.4974 17.7057Z"
                                    fill="#165FE3"
                                  />
                                  <path
                                    d="M9.5026 2.28906C9.06537 2.28906 8.71094 2.66216 8.71094 3.1224C8.71094 3.23153 8.73089 3.33575 8.76707 3.43128C8.76707 3.43128 9.21293 3.33073 9.5026 3.33073C9.79228 3.33073 10.2381 3.43128 10.2381 3.43128C10.2743 3.33575 10.2943 3.23153 10.2943 3.1224C10.2943 2.66216 9.93984 2.28906 9.5026 2.28906Z"
                                    fill="#165FE3"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M4.70144 2.87531C4.94313 3.1086 4.95938 3.50395 4.73775 3.75836C3.99278 4.6135 3.4453 5.66089 3.16992 6.82081C3.09042 7.15569 2.76806 7.35931 2.44993 7.27563C2.13179 7.19194 1.93835 6.85262 2.01786 6.51775C2.34239 5.15081 2.98717 3.91833 3.86254 2.91352C4.08417 2.65912 4.45976 2.642 4.70144 2.87531ZM14.6959 2.87531C14.9375 2.642 15.3131 2.65912 15.5347 2.91352C16.4102 3.91833 17.0549 5.15081 17.3795 6.51775C17.459 6.85262 17.2655 7.19194 16.9474 7.27563C16.6292 7.35931 16.3068 7.15569 16.2274 6.82081C15.952 5.66089 15.4045 4.6135 14.6595 3.75836C14.4379 3.50395 14.4542 3.1086 14.6959 2.87531Z"
                                    fill="#165FE3"
                                  />
                                </svg>
                              </div>
                            ) : (
                              <button className="text-sm w-full font-medium text-blue-700 border border-blue-700 rounded-[4px] py-[8px] px-4">
                                Set Reminder
                              </button>
                            )}
                          </button>
                        </PopoverTrigger>
                        <PopoverContent
                          alignOffset={10}
                          align="start"
                          className="rounded-lg z-50 gap-4 p-2.5 flex flex-col"
                        >
                          {!extraDetails?.reminder_time || editReminder ? (
                            <>
                              <DateTimePicker date={date} setDate={setDate} />
                              <Input
                                type="text"
                                value={followupNote}
                                defaultValue={extraDetails?.followup_note}
                                onChange={(e) =>
                                  setFollowupNote(e.target.value)
                                }
                                placeholder="Note (if any)"
                                className="w-full placeholder:text-[#999999] border-0 h-5 border-b border-gray-200 p-0 rounded-none focus:border-b focus:border-blue-700 focus-visible:ring-0 focus-visible:ring-offset-0"
                              />
                              {date && (
                                <div className="flex gap-2.5 items-center">
                                  <PopoverClose asChild>
                                    <button
                                      onClick={() => {
                                        setDate(undefined);
                                        setFollowupNote("");
                                        setEditReminder(false);
                                      }}
                                      className="text-sm w-full font-medium text-blue-700 border border-blue-700 rounded-[4px] py-[8px] px-4"
                                    >
                                      Cancel
                                    </button>
                                  </PopoverClose>
                                  <button
                                    onClick={async () => {
                                      if (param?.id) {
                                        try {
                                          await handlePartnerUpdate(
                                            parseInt(param?.id),
                                            "",
                                            date,
                                            followupNote,
                                          );
                                        } catch (error) {
                                          console.error(
                                            "Error updating partner:",
                                            error,
                                          );
                                          // Optionally set an error state to inform the user
                                        }
                                      }
                                      setEditReminder(false);
                                      setIsClearReminder(false);
                                    }}
                                    className="text-sm w-full font-medium border border-blue-700 rounded-[4px] py-[8px] px-4 bg-blue-700 text-white-A700"
                                  >
                                    Save
                                  </button>
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="flex flex-col gap-2.5">
                              <div className="flex flex-col items-start border-b border-gray-200 pb-2.5">
                                <p className="text-sm font-medium text-[#999999] flex w-full justify-between items-center">
                                  Reminder set for
                                  <button
                                    onClick={() => {
                                      setEditReminder(true);
                                      setDate(
                                        new Date(extraDetails?.reminder_time),
                                      );
                                      setFollowupNote(
                                        extraDetails?.reminder_note,
                                      );
                                    }}
                                    className=""
                                  >
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M3.33594 4.74609H2.5026C2.06058 4.74609 1.63665 4.92169 1.32409 5.23425C1.01153 5.54681 0.835938 5.97073 0.835938 6.41276V13.9128C0.835938 14.3548 1.01153 14.7787 1.32409 15.0913C1.63665 15.4038 2.06058 15.5794 2.5026 15.5794H10.0026C10.4446 15.5794 10.8686 15.4038 11.1811 15.0913C11.4937 14.7787 11.6693 14.3548 11.6693 13.9128V13.0794"
                                        stroke="#165FE3"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M10.8333 3.08472L13.3333 5.58472M14.4875 4.40556C14.8157 4.07735 15.0001 3.63221 15.0001 3.16806C15.0001 2.70391 14.8157 2.25876 14.4875 1.93056C14.1593 1.60235 13.7142 1.41797 13.25 1.41797C12.7858 1.41797 12.3407 1.60235 12.0125 1.93056L5 8.91806V11.4181H7.5L14.4875 4.40556Z"
                                        stroke="#165FE3"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </button>
                                </p>
                                <p className="">
                                  {formatUnixTimestamp(
                                    extraDetails?.reminder_time,
                                  )}
                                </p>
                              </div>

                              {!isClearReminder && (
                                <p className="text-sm font-medium text-[#999999]">
                                  {extraDetails?.reminder_note}
                                </p>
                              )}
                              {!isClearReminder && (
                                <button
                                  onClick={() => {
                                    (setDate(undefined),
                                      setIsClearReminder(true));
                                  }}
                                  className="text-sm w-full text-right font-medium text-blue-700 underline underline-offset-4"
                                >
                                  Clear Reminder
                                </button>
                              )}
                              {isClearReminder && (
                                <div className="flex flex-col gap-2.5 items-center w-full">
                                  <p className="">
                                    You will not be notified for a follow up.
                                    Are you sure you want to remove the reminder
                                    on this lead?
                                  </p>
                                  <div className="flex gap-2.5 items-center w-full">
                                    <button
                                      onClick={() => {
                                        clearReminder({
                                          onSuccess: getOpportunity,
                                          setLoading,
                                        });
                                      }}
                                      className="text-sm w-full font-medium text-blue-700 border border-blue-700 rounded-[4px] py-[8px] px-4"
                                    >
                                      Yes
                                    </button>
                                    <button
                                      onClick={() => setIsClearReminder(false)}
                                      className="text-sm w-full font-medium border border-blue-700 rounded-[4px] py-[8px] px-4 bg-blue-700 text-white-A700"
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </PopoverContent>
                      </Popover>

                      {/* summary */}
                      <Popover
                        onOpenChange={async (val) => {
                          if (val) {
                            await generateSummary();
                          }
                        }}
                      >
                        <PopoverTrigger>
                          <div className="flex items-center cursor-pointer">
                            <button
                              className="text-blue-700 opacity-50 cursor-not-allowed text-base leading-4 font-semibold bg-[#E1EBFC99] px-2 py-1.5 rounded-lg w-[81px] h-[28px] flex items-center justify-center"
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              Summary
                            </button>
                            <div className="relative bottom-1 ">
                              <svg
                                width="14"
                                height="16"
                                viewBox="0 0 14 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.6102 10.9659L10.6101 10.9655C10.6087 10.9616 10.6067 10.9596 10.6049 10.9583C10.6027 10.9569 10.5997 10.9559 10.5962 10.9559C10.5927 10.9559 10.5896 10.9569 10.5873 10.9584C10.5853 10.9597 10.5833 10.9618 10.5818 10.9659H10.6102ZM10.6102 10.9659L10.8389 11.6002L10.8389 11.6003C10.9669 11.955 11.1714 12.2771 11.4381 12.5437C11.7047 12.8104 12.0268 13.015 12.3815 13.1429L12.3816 13.1429L13.0158 13.3716C13.0158 13.3716 13.0158 13.3716 13.0159 13.3716C13.0187 13.3727 13.0212 13.3746 13.023 13.3771L13.064 13.3485L13.023 13.3771C13.0248 13.3797 13.0257 13.3827 13.0257 13.3858C13.0257 13.389 13.0248 13.392 13.023 13.3946L13.064 13.4232L13.023 13.3946C13.0212 13.3971 13.0187 13.399 13.0159 13.4001C13.0158 13.4001 13.0158 13.4001 13.0158 13.4001L12.3816 13.6287L12.3815 13.6288C12.0268 13.7567 11.7047 13.9613 11.4381 14.2279C11.1714 14.4946 10.9669 14.8167 10.8389 15.1714L10.8389 15.1715L10.6103 15.8057C10.6103 15.8057 10.6102 15.8057 10.6102 15.8057C10.6092 15.8086 10.6072 15.8111 10.6047 15.8129C10.6022 15.8147 10.5991 15.8157 10.596 15.8157C10.5929 15.8157 10.5898 15.8147 10.5873 15.8129C10.5848 15.8111 10.5828 15.8086 10.5818 15.8057C10.5818 15.8057 10.5817 15.8057 10.5817 15.8057L10.3531 15.1715L10.3531 15.1714C10.2251 14.8167 10.0206 14.4946 9.75393 14.2279C9.48729 13.9613 9.16516 13.7567 8.81046 13.6288L8.81045 13.6287L8.17624 13.4001C8.17621 13.4001 8.17617 13.4001 8.17614 13.4001C8.17325 13.399 8.17076 13.3971 8.169 13.3946C8.16721 13.392 8.16625 13.389 8.16625 13.3858C8.16625 13.3827 8.16721 13.3797 8.169 13.3771C8.17076 13.3746 8.17325 13.3727 8.17614 13.3716C8.17617 13.3716 8.17621 13.3716 8.17624 13.3716L8.81045 13.1429L8.81046 13.1429C9.16516 13.015 9.48729 12.8104 9.75393 12.5437C10.0206 12.2771 10.2251 11.955 10.3531 11.6003L10.3531 11.6002L10.5818 10.966L10.6102 10.9659ZM10.6572 10.9489L10.8859 11.5833C11.0114 11.9311 11.212 12.2469 11.4734 12.5084C11.7349 12.7698 12.0507 12.9704 12.3985 13.0959L10.6572 10.9489ZM10.6572 10.9489C10.637 10.8916 10.5555 10.8916 10.5348 10.9489H10.6572ZM4.96995 3.20353L4.97006 3.20383L5.42125 4.45685L5.42126 4.45687C5.67132 5.15071 6.07136 5.78084 6.59285 6.30235C7.11435 6.82387 7.74447 7.22392 8.43829 7.47399L8.4383 7.47399L9.69102 7.92509C9.69107 7.92511 9.69112 7.92513 9.69117 7.92515C9.70623 7.93071 9.71924 7.94075 9.72843 7.95391C9.73765 7.96712 9.7426 7.98285 9.7426 7.99896C9.7426 8.01507 9.73765 8.0308 9.72843 8.04401C9.71923 8.05717 9.70623 8.06721 9.69117 8.07277C9.69112 8.07278 9.69107 8.0728 9.69102 8.07282L8.4383 8.52392L8.43829 8.52393C7.74447 8.774 7.11435 9.17405 6.59285 9.69556C6.07136 10.2171 5.67132 10.8472 5.42126 11.541L5.42125 11.5411L4.97016 12.7938C4.97014 12.7939 4.97013 12.7939 4.97011 12.794C4.96455 12.809 4.95451 12.822 4.94135 12.8312C4.92814 12.8405 4.91241 12.8454 4.8963 12.8454C4.88019 12.8454 4.86447 12.8405 4.85126 12.8312C4.83809 12.822 4.82805 12.809 4.82249 12.794C4.82248 12.7939 4.82246 12.7939 4.82244 12.7938L4.37135 11.5411L4.37135 11.541C4.12128 10.8472 3.72125 10.2171 3.19975 9.69556C2.67825 9.17405 2.04814 8.774 1.35431 8.52393L1.3543 8.52392L0.101586 8.07282C0.101554 8.07281 0.101523 8.0728 0.101491 8.07279C0.0864045 8.06723 0.0733802 8.05719 0.0641733 8.04401C0.0549475 8.0308 0.05 8.01507 0.05 7.99896C0.05 7.98285 0.0549475 7.96712 0.0641733 7.95391C0.0733802 7.94073 0.0864043 7.93068 0.101492 7.92513C0.101523 7.92512 0.101554 7.92511 0.101586 7.92509L1.3543 7.47399L1.35431 7.47399C2.04814 7.22392 2.67825 6.82387 3.19975 6.30235C3.72125 5.78084 4.12128 5.15071 4.37135 4.45687L4.37135 4.45685L4.82254 3.20383L4.82265 3.20353C4.82803 3.18829 4.838 3.1751 4.85119 3.16576C4.86438 3.15643 4.88014 3.15142 4.8963 3.15142C4.91246 3.15142 4.92822 3.15643 4.94141 3.16576C4.95461 3.1751 4.96458 3.18829 4.96995 3.20353ZM10.8389 0.827029L10.8389 0.82704C10.9669 1.18175 11.1714 1.50389 11.4381 1.77053C11.7047 2.03717 12.0268 2.24176 12.3815 2.36973L12.3816 2.36973L13.0158 2.59837C13.0158 2.59838 13.0158 2.59838 13.0158 2.59839C13.0187 2.59946 13.0212 2.60139 13.023 2.60392L13.064 2.57525L13.023 2.60393C13.0248 2.60648 13.0257 2.60952 13.0257 2.61263C13.0257 2.61575 13.0248 2.61879 13.023 2.62134L13.064 2.65001L13.023 2.62134C13.0212 2.62387 13.0187 2.6258 13.0158 2.62687C13.0158 2.62688 13.0158 2.62689 13.0158 2.6269L12.3816 2.85553L12.3815 2.85554C12.0268 2.98351 11.7047 3.18809 11.4381 3.45473C11.1714 3.72137 10.9669 4.04351 10.8389 4.39822L10.8389 4.39824L10.6103 5.03247C10.6103 5.03249 10.6102 5.03252 10.6102 5.03255C10.6092 5.03544 10.6072 5.03794 10.6047 5.03971C10.6022 5.04149 10.5991 5.04245 10.596 5.04245C10.5929 5.04245 10.5898 5.04149 10.5873 5.03971C10.5848 5.03794 10.5828 5.03544 10.5818 5.03255C10.5818 5.03252 10.5817 5.03249 10.5817 5.03247L10.3531 4.39824L10.3531 4.39822C10.2251 4.04351 10.0206 3.72137 9.75393 3.45473C9.48729 3.18809 9.16516 2.98351 8.81046 2.85554L8.81045 2.85553L8.17624 2.6269C8.17621 2.62689 8.17619 2.62688 8.17616 2.62687C8.17327 2.6258 8.17077 2.62387 8.169 2.62134C8.16721 2.61879 8.16625 2.61575 8.16625 2.61263C8.16625 2.60952 8.16721 2.60648 8.169 2.60392C8.17077 2.60139 8.17328 2.59946 8.17618 2.59839C8.1762 2.59838 8.17622 2.59838 8.17624 2.59837L8.81045 2.36973L8.81046 2.36973C9.16516 2.24176 9.48729 2.03717 9.75393 1.77053C10.0206 1.50389 10.2251 1.18175 10.3531 0.82704L10.3531 0.827029L10.5817 0.192798C10.5817 0.192774 10.5818 0.19275 10.5818 0.192726C10.5828 0.189832 10.5848 0.187329 10.5873 0.185556C10.5898 0.18377 10.5929 0.182813 10.596 0.182813C10.5991 0.182813 10.6022 0.183771 10.6047 0.185556L10.6047 0.185558C10.6072 0.187329 10.6092 0.189829 10.6102 0.192725C10.6102 0.192749 10.6103 0.192774 10.6103 0.192798L10.8389 0.827029Z"
                                  fill="#AAC8FF"
                                  stroke="#A2A2A2"
                                  strokeWidth="0.1"
                                />
                              </svg>
                            </div>
                          </div>
                        </PopoverTrigger>
                        <PopoverContent
                          alignOffset={10}
                          align="end"
                          className="rounded-lg z-50 gap-2.5 p-4 w-[280px] sm:w-[350px] md:w-[450px] flex flex-col lg:w-[590px]"
                        >
                          <div className="flex items-center justify-between w-full">
                            <p className="font-normal text-xs text-[#999999] leading-[18px]">
                              Generated on {formatDate(Date.now().toString())}
                            </p>
                            <button
                              onClick={() => {
                                navigator.clipboard.writeText(summary);
                                toast.success("Copied to clipboard");
                              }}
                            >
                              <svg
                                width="13"
                                height="16"
                                viewBox="0 0 13 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9.93685 4.31075L9.93685 4.31028C9.93352 3.60136 9.35783 3.025 8.65111 3.025H1.67793C0.968395 3.025 0.392187 3.60121 0.392187 4.31075V14.3159C0.392187 15.0254 0.968395 15.6016 1.67793 15.6016H8.65111C9.36065 15.6016 9.93685 15.0254 9.93685 14.3159L9.93685 4.31075ZM8.90437 14.3128C8.90437 14.4542 8.78941 14.5691 8.64803 14.5691H1.67486C1.53349 14.5691 1.41852 14.4542 1.41852 14.3128V4.31075C1.41852 4.16937 1.53349 4.05441 1.67486 4.05441H8.64803C8.78941 4.05441 8.90437 4.16937 8.90437 4.31075V14.3128Z"
                                  fill="#165FE3"
                                  stroke="#165FE3"
                                  strokeWidth="0.2"
                                />
                                <path
                                  d="M11.3152 0.4H4.342C3.63246 0.4 3.05625 0.976207 3.05625 1.68575C3.05625 1.97137 3.28533 2.20045 3.57095 2.20045C3.85657 2.20045 4.08566 1.97137 4.08566 1.68575C4.08566 1.54437 4.20062 1.42941 4.342 1.42941H11.3152C11.4565 1.42941 11.5715 1.54437 11.5715 1.68575V11.6909C11.5715 11.8322 11.4565 11.9472 11.3152 11.9472C11.0295 11.9472 10.8005 12.1763 10.8005 12.4619C10.8005 12.7475 11.0295 12.9766 11.3152 12.9766C12.0247 12.9766 12.6009 12.4004 12.6009 11.6909V1.68575C12.6009 0.976207 12.0247 0.4 11.3152 0.4Z"
                                  fill="#165FE3"
                                  stroke="#165FE3"
                                  strokeWidth="0.2"
                                />
                              </svg>
                            </button>
                          </div>
                          <p className="font-normal text-sm text-black-label leading-[21px]">
                            {summary || (
                              <div className="space-y-2">
                                <Skeleton className="h-4 bg-gray-600 w-full rounded-full" />
                                <Skeleton className="h-4 bg-gray-600 w-full rounded-full" />
                                <Skeleton className="h-4 bg-gray-600 w-full rounded-full" />
                              </div>
                            )}
                          </p>
                        </PopoverContent>
                      </Popover>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="justify-between w-full flex items-center flex-wrap gap-3">
              {!isMobile && (
                <div className="flex gap-2.5 items-center">
                  <div className="flex gap-2.5 items-center">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.835 19.67C15.2667 19.67 19.67 15.2667 19.67 9.835C19.67 4.40328 15.2667 0 9.835 0C4.40328 0 0 4.40328 0 9.835C0 15.2667 4.40328 19.67 9.835 19.67Z"
                        fill="#F1F1F1"
                      />
                      <path
                        d="M9.83656 4.85938C7.80072 4.85938 6.14844 6.51165 6.14844 8.5475C6.14844 10.544 7.7122 12.1668 9.78739 12.2258C9.81689 12.2258 9.85623 12.2258 9.8759 12.2258C9.89557 12.2258 9.92508 12.2258 9.94475 12.2258C9.95458 12.2258 9.96442 12.2258 9.96442 12.2258C11.9511 12.1569 13.5149 10.544 13.5247 8.5475C13.5247 6.51165 11.8724 4.85938 9.83656 4.85938Z"
                        fill="#333333"
                      />
                      <path
                        d="M16.5081 17.0582C14.7575 18.6711 12.4168 19.6645 9.84001 19.6645C7.26324 19.6645 4.92251 18.6711 3.17188 17.0582C3.40791 16.1632 4.04719 15.3469 4.98152 14.7175C7.66647 12.9275 12.0332 12.9275 14.6985 14.7175C15.6427 15.3469 16.2721 16.1632 16.5081 17.0582Z"
                        fill="#333333"
                      />
                    </svg>

                    <p className="font-medium text-sm text-black-label">
                      {contactDetails?._rm?.fname}
                    </p>
                  </div>
                  <div className="">
                    <AlertDialog
                      onOpenChange={(open) => {
                        if (open)
                          relationShipManagerHandleChange(
                            relationShipManagerOptions?.find(
                              (option) =>
                                option?.value === contactDetails?._rm?.id,
                            ) as SingleValue<Option>,
                          );
                        // Handle any side effects when dialog opens/closes
                      }}
                    >
                      <AlertDialogTrigger asChild>
                        <div className="text-sm font-semibold text-blue-700 cursor-pointer hover:underline">
                          Reassign
                        </div>
                      </AlertDialogTrigger>
                      <AlertDialogPortal>
                        <AlertDialogOverlay className="  bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
                        <AlertDialogContent className="bg-white-A700 rounded-lg p-0 w-full animate-contentShow">
                          <AlertDialogHeader className="flex text-left border-b  rounded-t py-3 px-10 ">
                            <AlertDialogTitle className="font-bold p-0 text-lg text-black-label">
                              Select the staff to assign
                            </AlertDialogTitle>
                            <AlertDialogDescription></AlertDialogDescription>
                          </AlertDialogHeader>
                          <form className="px-10 w-full flex py-3 flex-col gap-2">
                            <label
                              htmlFor="staff_select"
                              className=" text-sm font-medium "
                            >
                              Choose a staff
                            </label>
                            <ReactSelect
                              menuPlacement="auto"
                              className=""
                              menuPosition="absolute"
                              placeholder="Select the staff"
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  zIndex: 0,
                                  borderRadius: ".5rem",
                                  padding: ".4rem",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderColor: state.isFocused
                                    ? "#165FE3"
                                    : "#333333",
                                  boxShadow: "none",
                                }),
                                menu: (provided, state) => ({
                                  ...provided,
                                  zIndex: 1000,
                                }),
                              }}
                              options={relationShipManagerOptions}
                              onChange={relationShipManagerHandleChange}
                              value={relationShipManagerSelectedOption}
                              name="staff_select"
                              id="staff_select"
                            />
                          </form>
                          <AlertDialogFooter className="flex justify-start items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
                            <AlertDialogCancel
                              className=" m-0 rounded-lg border-blue-700 border py-[11px] px-4 text-blue-700"
                              asChild
                            >
                              <button>Cancel</button>
                            </AlertDialogCancel>
                            <AlertDialogAction
                              className="rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700"
                              asChild
                            >
                              <button
                                className="disabled:opacity-50"
                                disabled={
                                  loading || !relationShipManagerSelectedOption
                                }
                                onClick={() =>
                                  handlePartnerUpdate(
                                    parseInt(param?.id),
                                    relationShipManagerSelectedOption?.value,
                                    "",
                                    "",
                                  )
                                }
                              >
                                {loading ? "Reassigning..." : "Submit"}
                              </button>
                            </AlertDialogAction>
                          </AlertDialogFooter>
                        </AlertDialogContent>
                      </AlertDialogPortal>
                    </AlertDialog>
                  </div>
                </div>
              )}

              <div className="flex flex-row sm:flex-col items-center gap-5">
                {/* Thumbs Down Section */}
                <div className="gap-3 h-fit hidden md:flex">
                  {opportunityDetails?.isOpportunityOpen === "open" ? (
                    <DropdownMenu modal>
                      <DropdownMenuTrigger
                        disabled={
                          opportunityDetails?.isOpportunityOpen === "close"
                        }
                      >
                        <div className="flex items-center h-fit">
                          <div className="p-2 bg-red-50 rounded-lg w-[90px] h-[50px] flex items-center justify-center">
                            <ThumbsDown className="text-red-500" size={28} />
                          </div>
                        </div>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent
                        className="border p-0 rounded-lg border-gray-300"
                        avoidCollisions
                        align="end"
                        alignOffset={10}
                      >
                        <DropdownMenuRadioGroup
                          value={reason}
                          onValueChange={(e) => {
                            setReason(e);
                            handleUpdateOpportunity(e, "", "");
                          }}
                        >
                          <DropdownMenuLabel className="bg-gray-100 rounded-t py-3 px-4 text-base font-medium border-b">
                            Give reason for closing the opportunity.
                          </DropdownMenuLabel>
                          {opportunityCloseReason.map((reason) => (
                            <DropdownMenuRadioItem
                              key={reason.value}
                              value={reason.value}
                              className="py-3 px-4 cursor-pointer hover:bg-gray-200 bg-white text-sm font-normal"
                            >
                              {reason.label}
                            </DropdownMenuRadioItem>
                          ))}
                        </DropdownMenuRadioGroup>
                      </DropdownMenuContent>
                    </DropdownMenu>
                  ) : (
                    opp_status()
                  )}
                </div>
                <div className="flex flex-row sm:flex-col items-center gap-5 justify-center">
                  <div className="flex flex-row gap-[3px] sm:gap-[10px]">
                    <DigitalInterestDropdown
                      onSubmit={handleUpdateDigitalInterest}
                      items={partnerInterestItems}
                      selectedValue={contactDetails?.digital_interest}
                      loading={isLoading}
                    />
                    <DropdownMenu>
                      <DropdownMenuTrigger className="cursor-pointer" asChild>
                        <div
                          className="flex items-center justify-between px-3 py-2 md:px-1 md:py-[3px] h-[44px] sm:h-auto cursor-pointer rounded-[6px] border w-full whitespace-nowrap space-x-[10px] md:space-x-[4px]"
                          style={{
                            color: partner_contact_status.find(
                              (status) =>
                                status.value ===
                                (contactDetails?.lead_status === "new" &&
                                interactionList?.length > 0
                                  ? "contacted"
                                  : contactDetails?.lead_status),
                            )?.textColor,
                            backgroundColor: partner_contact_status.find(
                              (status) =>
                                status.value ===
                                (contactDetails?.lead_status === "new" &&
                                interactionList?.length > 0
                                  ? "contacted"
                                  : contactDetails?.lead_status),
                            )?.bgColor,
                          }}
                        >
                          <span className="text-sm md:text-xs leading-4 font-medium">
                            {partner_contact_status.find(
                              (status) =>
                                status.value ===
                                (contactDetails?.lead_status === "new" &&
                                interactionList?.length > 0
                                  ? "contacted"
                                  : contactDetails?.lead_status),
                            )?.label || "Select Status"}
                          </span>
                          <ChevronDown
                            color="black"
                            className="w-4 h-4 md:h-3 md:w-3"
                          />
                        </div>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent className="p-1">
                        {partner_contact_status
                          .filter(
                            (status) =>
                              status.value !== "new" &&
                              status.value !== "lead" &&
                              status.value !== "archived" &&
                              status.value !== "pending" &&
                              status.value !== "incomplete",
                          )
                          .map((status) => (
                            <DropdownMenuItem
                              key={status.value}
                              onSelect={() => {
                                setSelectedLeadStatus(status?.value);
                              }}
                              className="text-sm md:text-xs cursor-pointer rounded-[6px] text-left mb-1 min-w-full flex flex-row hover:bg-gray-100 p-2"
                              style={{
                                color: status.textColor,
                                backgroundColor: status.bgColor,
                              }}
                            >
                              {status.label}
                            </DropdownMenuItem>
                          ))}
                      </DropdownMenuContent>
                    </DropdownMenu>

                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <Button
                          variant="outline"
                          className={`flex items-center justify-between border rounded-md px-3 py-2 md:px-1 md:py-[3px] h-auto sm:h-10 min-w-[160px] md:min-w-[100px] whitespace-nowrap ${
                            stageTags?.find(
                              (tag) => tag.value === contactDetails?.stage_tags,
                            )?.color || "bg-gray-100"
                          }`}
                        >
                          <div className="flex items-center gap-2 text-sm md:text-xs">
                            {contactDetails?.stage_tags && (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html:
                                    stageTags?.find(
                                      (tag) =>
                                        tag.value ===
                                        contactDetails?.stage_tags,
                                    )?.icon || "",
                                }}
                              />
                            )}
                            <span>
                              {stageTags?.find(
                                (tag) =>
                                  tag.value === contactDetails?.stage_tags,
                              )?.label || "Select Tag"}
                            </span>
                          </div>
                          <ChevronDown
                            color="black"
                            className="w-4 h-4 md:h-3 md:w-3"
                          />
                        </Button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent className="w-28 p-0 rounded-lg">
                        {stageTags?.map((tag) => (
                          <DropdownMenuItem
                            key={tag.value}
                            onClick={() => handleUpdateStage(tag.value)}
                            className={`${tag.color} cursor-pointer`}
                          >
                            <p
                              dangerouslySetInnerHTML={{
                                __html: `${tag.icon || ""}`,
                              }}
                              className="mr-2 p-2"
                            ></p>
                            {tag.label}
                          </DropdownMenuItem>
                        ))}
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </div>
                  {/* Thumbs Up Section */}
                  <button
                    className={`text-white-A700 bg-blue-700 sm:whitespace-nowrap w-full rounded-lg py-3 px-4 ${
                      opportunityDetails?.isOpportunityOpen === "close"
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-[#165FE3]"
                    }`}
                    onClick={() => {
                      // The lead already is the partner record: the form
                      // opens prefilled and registers this same row.
                      navigate(`/partnerregistration?lead=${param?.id}`);
                    }}
                  >
                    Register Partner
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex h-full overflow-auto sm:overflow-visible px-2 lg:px-2 bg-white-A700 rounded-lg">
          <Tabs
            value={activeTab}
            onValueChange={(value) => {
              setActiveTab(value);
            }}
            className="w-full mt-4 sm:overflow-hidden"
          >
            {/* <TabsList className="bg-navbar-menu-bg hide-scrollbar flex justify-between rounded-xl gap-2 py-3.5"> */}
            {isMobile ? (
              <Accordion
                type="single"
                collapsible
                className="w-full"
                value={isOpen ? "dropdown" : ""}
                onValueChange={(val) => setIsOpen(val === "dropdown")}
              >
                <AccordionItem value="dropdown">
                  <AccordionTrigger className="text-sm font-semibold px-4 py-2 bg-[#EFF4FF] border-b-[#C4D7F9] border-t-[#C4D7F9]  text-blue-600 h-12">
                    {partnerSheetTabs?.find((tab) => tab.value === activeTab)
                      ?.label || "Select Tab"}
                  </AccordionTrigger>

                  <AccordionContent className="bg-[#f1f5ff] rounded-lg px-4 py-2 space-y-2">
                    {partnerSheetTabs
                      .filter((tab) => tab.value !== activeTab)
                      .map((tab) => (
                        <div
                          key={tab?.id + tab.value}
                          className="text-gray-700 hover:text-[#165FE3] cursor-pointer text-base font-semibold"
                          onClick={() => handleSelectTab(tab.value)}
                        >
                          {tab.label}
                        </div>
                      ))}
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            ) : (
              <TabsList className="hide-scrollbar overflow-auto flex justify-start border-b border-[#C4D7F9] bg-transparent gap-0 w-full">
                {partnerSheetTabs.map((tab) => (
                  <TabsTrigger
                    key={tab.value}
                    value={tab.value}
                    className={`relative px-8 py-3 text-base transition-colors min-w-[220px] w-full
                        ${
                          tab.value === activeTab
                            ? "text-blue-600 bg-blue-50 border-b border-white"
                            : "text-gray-500"
                        }
                        ${
                          tab.value === activeTab
                            ? "before:absolute before:top-0 before:left-0 before:w-full before:h-0.5 before:bg-blue-600"
                            : ""
                        }
                        ${
                          tab.value === activeTab
                            ? "font-semibold"
                            : "font-semibold"
                        }
                        font-inter text-[18px] font-[500] leading-[16px] text-center `}
                  >
                    {tab.label}
                  </TabsTrigger>
                ))}
              </TabsList>
            )}
            <TabsContent className="" value="interaction">
              {isMobile ? (
                <div className="h-[calc(100vh-200px)] overflow-y-auto px-2 space-y-4 scrollbar-hide">
                  <ForexOrderInteractionCard
                    columns={InteractionColumn}
                    data={interactionList}
                    onRowClick={() => {}}
                    isPaginationVisible={interactionList?.length > 10}
                    defaultSorting={[{ id: "createdAt", desc: true }]}
                    isPageCountVisible={interactionList?.length > 10}
                  />
                </div>
              ) : (
                <div className="flex gap-0 flex-col">
                  <DataTable
                    columns={InteractionColumn}
                    data={interactionList}
                    isToolbarVisible={false}
                    isPaginationVisible={interactionList.length > 10}
                    defaultSorting={[{ id: "createdAt", desc: true }]}
                    isPageCountVisible={interactionList.length > 10}
                  />
                </div>
              )}
            </TabsContent>

            <TabsContent value="details">
              <div className="flex p-4 md:py-5 md:px-0 justify-between gap-8 w-full">
                <div className="flex flex-col gap-2.5 w-full">
                  <div className="flex flex-col gap-4  p-2.5 w-full  rounded-xl bg-[#F9F9F9] ">
                    {contactInsheetDetail.map((item, index) => {
                      if (item.value === "location") {
                        return (
                          <TooltipProvider key={index}>
                            <Tooltip>
                              <TooltipTrigger
                                className="flex cursor-pointer items-end"
                                asChild
                              >
                                <div className="flex items-center gap-2.5">
                                  {item.icon}
                                  <div className="font-medium text-sm text-ellipsis text-black-label">
                                    {contactDetails?.[
                                      item.value as keyof typeof contactDetails
                                    ]?.substring(0, 30) ?? "Not Available"}
                                  </div>
                                  {contactDetails?.location && (
                                    <button
                                      onClick={() => {
                                        navigator.clipboard.writeText(
                                          (contactDetails?.[
                                            item.value as keyof typeof contactDetails
                                          ] as string) ?? "Not Available",
                                        );
                                        toast.success("Copied to clipboard");
                                      }}
                                      className=""
                                    >
                                      <svg
                                        width="13"
                                        height="16"
                                        viewBox="0 0 13 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M9.93685 4.31075L9.93685 4.31028C9.93352 3.60136 9.35783 3.025 8.65111 3.025H1.67793C0.968395 3.025 0.392187 3.60121 0.392187 4.31075V14.3159C0.392187 15.0254 0.968395 15.6016 1.67793 15.6016H8.65111C9.36065 15.6016 9.93685 15.0254 9.93685 14.3159L9.93685 4.31075ZM8.90437 14.3128C8.90437 14.4542 8.78941 14.5691 8.64803 14.5691H1.67486C1.53349 14.5691 1.41852 14.4542 1.41852 14.3128V4.31075C1.41852 4.16937 1.53349 4.05441 1.67486 4.05441H8.64803C8.78941 4.05441 8.90437 4.16937 8.90437 4.31075V14.3128Z"
                                          fill="#165FE3"
                                          stroke="#165FE3"
                                          stroke-width="0.2"
                                        />
                                        <path
                                          d="M11.3152 0.4H4.342C3.63246 0.4 3.05625 0.976207 3.05625 1.68575C3.05625 1.97137 3.28533 2.20045 3.57095 2.20045C3.85657 2.20045 4.08566 1.97137 4.08566 1.68575C4.08566 1.54437 4.20062 1.42941 4.342 1.42941H11.3152C11.4565 1.42941 11.5715 1.54437 11.5715 1.68575V11.6909C11.5715 11.8322 11.4565 11.9472 11.3152 11.9472C11.0295 11.9472 10.8005 12.1763 10.8005 12.4619C10.8005 12.7475 11.0295 12.9766 11.3152 12.9766C12.0247 12.9766 12.6009 12.4004 12.6009 11.6909V1.68575C12.6009 0.976207 12.0247 0.4 11.3152 0.4Z"
                                          fill="#165FE3"
                                          stroke="#165FE3"
                                          stroke-width="0.2"
                                        />
                                      </svg>
                                    </button>
                                  )}
                                </div>
                              </TooltipTrigger>
                              <TooltipContent
                                side="bottom"
                                className="bg-black-900 text-white-A700 max-w-[200px] whitespace-normal break-words border-0"
                              >
                                {contactDetails?.[
                                  item.value as keyof typeof contactDetails
                                ] ?? "Not Available"}
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        );
                      }
                      return (
                        <div key={index} className="flex items-center gap-2.5">
                          {item.icon}
                          <span className="font-medium text-sm text-black-label">
                            {primaryContact?.[
                              item.value as keyof typeof primaryContact
                            ] || "N/A"}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="flex hidden flex-col gap-2.5 w-full flex-grow h-full">
                  <h5 className="text-sm font-medium leading-4 text-[#999999]">
                    Lead Details
                  </h5>
                  <div className="flex flex-col gap-4 p-2.5 rounded-xl bg-[#F9F9F9] w-full">
                    <div className="flex gap-2.5 items-center">
                      <span className="text-[#666666] font-medium text-sm ">
                        Product
                      </span>
                      {/* <span className="font-medium text-sm text-black-label">
                      {rowData.product}
                    </span> */}
                      <span className="text-[#999999] font-medium text-sm">
                        {`(${opportunityDetails?.productSubcategory})`}
                      </span>
                    </div>
                    <div className="flex gap-2.5 items-center">
                      <span className="text-[#666666] font-medium text-sm ">
                        Channel
                      </span>
                      <span className="font-medium text-sm text-black-label">
                        {channelDetails?.channel === "Refferal"
                          ? "Referral"
                          : channelDetails?.channel}
                      </span>
                      <span className="text-[#999999] font-medium text-sm">
                        {(() => {
                          if (channelDetails?.source) {
                            if (
                              ["outletID", "partnerOffice"].includes(
                                channelDetails?.source,
                              )
                            ) {
                              if (channelDetails?.channel === "Refferal") {
                                return extraDetails?.staffId
                                  ? `(${extraDetails?.staffName})`
                                  : `(${extraDetails?.partnerName})`;
                              } else if (
                                channelDetails?.channel === "Walk-in"
                              ) {
                                return `(${extraDetails?.branchName})`;
                              } else {
                                return ``;
                              }
                            } else {
                              return `(${channelDetails?.source})`;
                            }
                          } else {
                            return "";
                          }
                        })()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </TabsContent>

            <TabsContent value="notes">
              {!detailNotes ? (
                <div className="flex items-center p-4 md:py-5 md:px-0 gap-5 w-full">
                  <div className=" bg-[#FAFAFA] w-full flex items-center gap-2 py-2.5 px-2 rounded-lg text-left">
                    <div className="flex items-center justify-between w-full">
                      <div className="flex flex-col gap-1">
                        {" "}
                        <p className="font-normal font-inter text-xs leading-[18px] text-[#999999]">
                          {extraDetails?.note_last_edited ? (
                            <>
                              last edited on{" "}
                              {formatUnixTimestamp(
                                extraDetails.note_last_edited,
                              )}
                            </>
                          ) : (
                            "Click on icon to add note"
                          )}
                        </p>
                        <p className="font-normal text-sm font-inter leading-[18px] text-[#333333]  whitespace-pre-wrap">
                          {extraDetails?.notes}
                        </p>
                      </div>
                      <button
                        onClick={() => {
                          if (extraDetails?.notes)
                            setInputValue(extraDetails?.notes);
                          setDetailNotes(true);
                        }}
                        className=""
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.33594 4.24609H2.5026C2.06058 4.24609 1.63665 4.42169 1.32409 4.73425C1.01153 5.04681 0.835938 5.47073 0.835938 5.91276V13.4128C0.835938 13.8548 1.01153 14.2787 1.32409 14.5913C1.63665 14.9038 2.06058 15.0794 2.5026 15.0794H10.0026C10.4446 15.0794 10.8686 14.9038 11.1811 14.5913C11.4937 14.2787 11.6693 13.8548 11.6693 13.4128V12.5794"
                            stroke="#165FE3"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M10.8333 2.58472L13.3333 5.08472M14.4875 3.90556C14.8157 3.57735 15.0001 3.13221 15.0001 2.66806C15.0001 2.20391 14.8157 1.75876 14.4875 1.43056C14.1593 1.10235 13.7142 0.917969 13.25 0.917969C12.7858 0.917969 12.3407 1.10235 12.0125 1.43056L5 8.41806V10.9181H7.5L14.4875 3.90556Z"
                            stroke="#165FE3"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                    {/* <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger
                          className="flex cursor-pointer items-end"
                          asChild
                        >
                          <p className="">
                            {(contactDetails?.notes as string)?.length > 30
                              ? contactDetails?.notes.substring(0, 40) + "..."
                              : contactDetails?.notes}
                          </p>
                        </TooltipTrigger>
                        <TooltipContent
                          side="bottom"
                          className="bg-black-900 text-white-A700 max-w-[400px] whitespace-normal break-words border-0"
                        >
                          {contactDetails?.notes ?? "Not Available"}
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider> */}
                  </div>
                </div>
              ) : (
                <div className="flex p-4 items-center justify-between w-full">
                  <textarea
                    value={inputValue}
                    onChange={(e) => {
                      setInputValue(e.target.value);
                    }}
                    rows={5}
                    className="w-full border rounded-md border-black border-solid flex-1 px-2 py-2 mr-4"
                  />
                  <button
                    onClick={() => {
                      handlePartnerUpdate(
                        param?.id,
                        "",
                        "",
                        "",
                        "",
                        "",
                        inputValue,
                      );
                      setDetailNotes(false);
                    }}
                    className=" text-white-A700 bg-blue-700 whitespace-nowrap rounded-lg py-2 px-4"
                  >
                    Save
                  </button>
                </div>
              )}
            </TabsContent>
            <TabsContent value="team" className="flex-1">
              <div
                className="grid p-4 gap-4 
                  grid-cols-1 
                  md:grid-cols-1 
                  lg:grid-cols-2"
              >
                {teamMember?.map((member, index) => (
                  <Card
                    key={member.id}
                    className="w-full bg-[#FAFAFA] hover:bg-[#F3F7FF] border-0 hover:border hover:border-[#165FE3] hover:border-solid"
                  >
                    <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                      <div className="flex flex-col space-y-1.5">
                        <h2 className="font-semibold leading-none tracking-tight">
                          <div className="flex flex-row items-center justify-between">
                            <p>
                              {member.full_name}
                              {member.relation_with_partner && (
                                <span className="text-[#666666] font-inter text-[12px] font-normal leading-[12px] text-left underline-offset-auto px-1 ml-1 rounded-md bg-[#F1F1F1]">
                                  {member.relation_with_partner}
                                </span>
                              )}
                            </p>
                          </div>
                        </h2>
                      </div>
                      <div className="flex items-center gap-2">
                        <p className="text-[#C4C4C4] font-inter italic text-sm">
                          {member?.isPrimary_partner ? "Primary" : ""}
                        </p>
                        <Button variant="ghost" size="icon" className="h-8 w-8">
                          <DropdownMenu>
                            <DropdownMenuTrigger>
                              <MoreVertical className="h-4 w-4" />
                            </DropdownMenuTrigger>
                            <DropdownMenuContent className="p-2">
                              <button
                                onClick={() => handleSetAsPrimary(member.id)}
                                className="text-sm text-left w-full hover:bg-gray-100 p-2"
                              >
                                Set as primary
                              </button>
                            </DropdownMenuContent>
                          </DropdownMenu>
                        </Button>
                      </div>
                    </CardHeader>

                    <CardContent className="grid gap-4">
                      <div className="flex items-center gap-2">
                        <Mail className="h-4 w-4 text-muted-foreground" />
                        <a
                          href={`mailto:${member.email}`}
                          className="text-sm hover:underline"
                        >
                          {member.email || "N/A"}
                        </a>
                      </div>
                      <div className="flex items-center gap-2">
                        <Phone className="h-4 w-4 text-muted-foreground" />
                        <a
                          href={`tel:${member.phone_number}`}
                          className="text-sm hover:underline"
                        >
                          {member.phone_number || "N/A"}
                        </a>
                      </div>
                      <div className="text-xs text-muted-foreground pt-2 border-t">
                        Linked on{" "}
                        {formatUnixTimestamp(member?.partner_linked_at)} by{" "}
                        {member?._partner_linked_by?.fname || "N/A"}
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </TabsContent>
          </Tabs>
        </div>

        {/* interaction */}
        {isMobile ? (
          <Sheet open={isInteractionModal} onOpenChange={setIsInteractionModal}>
            <SheetTrigger asChild>
              <div
                className="relative"
                onClick={() => setIsInteractionModal(true)}
              >
                <button className="" />
                <div className="fixed bottom-0 left-0 right-0 mx-2 z-50 transition-all duration-300 ease-out bg-white shadow-lg rounded-t-2xl">
                  <button className="cursor-pointer w-full flex items-center justify-center h-12 bg-white-A700 border-t border-blue-700 rounded-t-2xl">
                    <span className="text-blue-700 text-sm font-semibold">
                      + Add Interaction
                    </span>
                  </button>
                </div>
              </div>
            </SheetTrigger>
            <SheetOverlay />
            <SheetContent
              className="bg-white-A700 px-2 pt-3 pb-5 h-auto"
              side="bottom"
            >
              <div className=" bg-white z-70 relative rounded-t-2xl bg-white-A700">
                <div className="flex w-full items-center justify-center pb-[18px]">
                  <div className="flex relative items-center justify-center w-full ">
                    <p className="text-base text-blue-700 font-bold ">
                      + Add Interaction
                    </p>
                  </div>
                </div>
                {isUploadScreen ? (
                  <>
                    <div className="p-4 w-full bg-white">
                      <p className="text-base font-medium text-[#333333] mb-4">
                        Click/upload a photo covering yourself and partner’s
                        office.
                      </p>

                      <div className="flex justify-center mb-5">
                        <img
                          className="w-[171px] h-[98.31px] rounded-[5.54px] border border-gray-300 object-cover"
                          src={
                            previewUrl ||
                            (methods2.getValues("office_photo") &&
                            typeof methods2.getValues("office_photo") ===
                              "string" &&
                            methods2.getValues("office_photo") !==
                              "data:application/octet-stream;base64,"
                              ? methods2.getValues("office_photo")
                              : "/images/Selfie.png")
                          }
                          alt="Office photo preview"
                        />
                      </div>

                      <div className="flex justify-center mb-5">
                        <label className="cursor-pointer">
                          <input
                            id="photo_upload_input"
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={(e) => {
                              if (e.target.files?.[0]) {
                                handleMobileFileChange(e.target.files[0]);
                              }
                            }}
                          />
                          <div className="h-12 flex items-center justify-center px-4 py-2.5 font-semibold text-sm text-[#165FE3] bg-white border border-blue-600 rounded-lg shadow-sm transition-colors hover:bg-blue-50 max-w-[150px] w-full">
                            {methods2.getValues("office_photo")
                              ? "Re-upload"
                              : "Upload Photo"}
                          </div>
                        </label>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {/* {textarea condition} */}
                    <div className="mb-4">
                      <textarea
                        onChange={(e) => {
                          setInteractionNote(e.target.value);
                        }}
                        value={interactionNote}
                        className="w-full p-3 border border-black-200 rounded-xl text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-500 bg-white"
                        placeholder="Write your notes here..."
                        rows={3}
                        style={{ resize: "none" }}
                      />
                    </div>

                    {/* below condition */}
                    <div className="grid grid-cols-2 gap-3 mb-4">
                      <Select
                        disabled={selectedType === "outbound"}
                        onValueChange={(val) => {
                          setSelectedType("inbound");
                          setSelectedChannelOption(val);
                          if (val === "3") {
                            setIsNextBtn(true);
                          }
                        }}
                        value={
                          selectedType === "inbound"
                            ? selectedChannelOption
                            : ""
                        }
                      >
                        <SelectTrigger
                          hideIcon
                          className={`${
                            selectedType === "outbound"
                              ? "hidden"
                              : selectedType !== ""
                                ? "col-span-2"
                                : ""
                          } bg-[#E1EBFC] border-none hover:bg-blue-100 focus:ring-0 focus:ring-offset-0 whitespace-nowrap relative`}
                        >
                          <div className="flex gap-3 items-center">
                            <SelectValue placeholder="I contacted" />
                            {!selectedChannelOption && (
                              <ChevronDown className="h-4 w-4 text-blue-600 ml-10 pointer-events-none" />
                            )}
                          </div>
                          {selectedChannelOption && (
                            <X
                              className="h-4 w-4 z-50 text-blue-600 ml-2 cursor-pointer border border-blue-700 rounded-full"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                setSelectedType("");
                                setSelectedChannelOption("");
                                setIsNextBtn(false);
                              }}
                            />
                          )}
                        </SelectTrigger>
                        {selectedChannelOption &&
                          selectedChannelOption === "3" && (
                            <div
                              className={
                                "col-span-2 border-none bg-[#fff] h-auto mb-2"
                              }
                            >
                              <div className="flex flex-col gap-2">
                                <div className="">
                                  <form className="w-full" action="">
                                    <label
                                      htmlFor="ll"
                                      className="font-medium text-sm items-start justify-start whitespace-nowrap leading-[18.2px] text-[#333333]"
                                    >
                                      Search & add team members
                                    </label>
                                    <ReactSelect
                                      closeMenuOnSelect={false}
                                      styles={{
                                        control: (provided, state) => ({
                                          ...provided,
                                          zIndex: 0,
                                          borderRadius: ".5rem",
                                          padding: ".3rem",
                                          borderColor: state.isFocused
                                            ? "#165FE3"
                                            : "#333333",
                                          boxShadow: "none",
                                          width: "100%",
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 1000,
                                          width: "100%",
                                        }),
                                        container: (provided) => ({
                                          ...provided,
                                          width: "100%",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }),
                                      }}
                                      components={{
                                        DropdownIndicator: () => (
                                          <div className="pr-1">
                                            <svg
                                              width="20"
                                              height="20"
                                              viewBox="0 0 20 20"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <g clipPath="url(#clip0_2821_158352)">
                                                <path
                                                  d="M10.0991 18.6318L10.0988 18.6318C9.94355 18.6313 9.79483 18.5695 9.68508 18.4597C9.57533 18.35 9.51347 18.2012 9.51301 18.046L9.513 18.0456L9.51149 10.59L2.05583 10.5884L2.04426 10.5884L2.04429 10.588C1.89676 10.5766 1.75897 10.5099 1.65846 10.4013C1.55795 10.2927 1.50211 10.1502 1.50211 10.0022C1.50211 9.85428 1.55795 9.71176 1.65846 9.60317C1.75897 9.49457 1.89676 9.42791 2.04429 9.4165L2.05583 9.4156L2.05583 9.41605L9.51143 9.41453L9.50991 1.95893L9.50992 1.9589C9.50992 1.80302 9.57184 1.65353 9.68206 1.54331C9.79228 1.43308 9.94178 1.37116 10.0977 1.37116M10.0991 18.6318L10.0977 1.37116L10.0977 1.52072L10.0977 1.37116M10.0991 18.6318C10.1763 18.6318 10.2528 18.6167 10.3241 18.5871L10.2669 18.4489L10.3241 18.5871C10.3955 18.5576 10.4603 18.5143 10.5149 18.4597C10.5695 18.4051 10.6128 18.3403 10.6423 18.269L10.5037 18.2116L10.6423 18.269C10.6718 18.1976 10.687 18.1212 10.6869 18.044L10.6869 10.59L18.1425 10.5884C18.1426 10.5884 18.1426 10.5884 18.1426 10.5884C18.2984 10.5884 18.4479 10.5265 18.5581 10.4163C18.6684 10.3061 18.7303 10.1566 18.7303 10.0007C18.7303 9.84482 18.6684 9.69532 18.5581 9.5851C18.4479 9.47488 18.2984 9.41295 18.1425 9.41295L18.1425 9.41295L10.6869 9.41447L10.6854 1.9589C10.6854 1.95889 10.6854 1.95888 10.6854 1.95887C10.6854 1.803 10.6235 1.65352 10.5133 1.54331C10.403 1.43308 10.2535 1.37116 10.0977 1.37116M10.0991 18.6318L10.0977 1.37116"
                                                  fill="#165FE3"
                                                  stroke="#165FE3"
                                                  stroke-width="0.3"
                                                />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_2821_158352">
                                                  <rect
                                                    width="14"
                                                    height="14"
                                                    fill="white"
                                                    transform="translate(0.203125 10) rotate(-45)"
                                                  />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                          </div>
                                        ),
                                        IndicatorSeparator: () => null,
                                        MultiValue: ({
                                          children,
                                          ...props
                                        }) => {
                                          const { selectProps } = props;
                                          const selectedCount =
                                            selectProps?.value?.length;
                                          if (props.index === 0) {
                                            return (
                                              <div className="flex items-center">
                                                {children}
                                                {selectedCount > 1 && (
                                                  <span className="ml-2 text-sm text-gray-500">
                                                    +{selectedCount - 1}
                                                  </span>
                                                )}
                                              </div>
                                            );
                                          }
                                          return null;
                                        },
                                      }}
                                      isMulti
                                      name="people"
                                      onChange={(val) =>
                                        setSelectedStaffOptions(val as Option[])
                                      }
                                      options={staffs}
                                      menuPlacement="top"
                                      className="rounded-lg w-full"
                                      placeholder="Select Staff"
                                    />
                                  </form>
                                </div>
                              </div>
                            </div>
                          )}
                        {selectedChannelOption === "3" &&
                          selectedStaffOptions?.length > 0 && (
                            <div className="col-span-2 border-none bg-[#fff] h-auto mb-2">
                              <label
                                htmlFor="ll"
                                className="font-medium text-sm items-start justify-start whitespace-nowrap leading-[18.2px] text-[#333333]"
                              >
                                Contacted with
                              </label>
                              <Select
                                value={selectedContact}
                                onValueChange={(val) => {
                                  setSelectedContact(val);
                                }}
                              >
                                <SelectTrigger className="w-full whitespace-nowrap">
                                  <SelectValue placeholder="Contacted with" />
                                </SelectTrigger>
                                <SelectContent>
                                  {!teamMember?.length ? (
                                    <Skeleton className="h-4 bg-gray-600 w-full rounded-full" />
                                  ) : (
                                    teamMember?.map((item) => (
                                      <SelectItem
                                        key={item?.id}
                                        value={String(item?.id)}
                                      >
                                        {item?.full_name}
                                      </SelectItem>
                                    ))
                                  )}
                                </SelectContent>
                              </Select>
                            </div>
                          )}

                        {selectedStaffOptions?.length > 0 && (
                          <div className="col-span-2 border-none bg-[#fff] h-auto mb-2 w-full">
                            <form action="">
                              <label
                                htmlFor="ll"
                                className="font-medium text-sm leading-[18.2px]"
                              >
                                Select team
                              </label>
                              <DateTimePicker
                                fromDate={new Date("2000-01-01")}
                                date={meetingTime}
                                setDate={setMeetingTime}
                              />
                            </form>
                          </div>
                        )}
                        <SelectContent>
                          <SelectGroup>
                            {channel_options_inbound
                              // .filter((val) => val.label !== "Meeting")
                              .map((channel) => (
                                <SelectItem
                                  className="cursor-pointer hover:bg-[#e5eff3]"
                                  key={channel.value}
                                  value={channel.value.toString()}
                                >
                                  {channel.label}
                                </SelectItem>
                              ))}
                          </SelectGroup>
                        </SelectContent>
                      </Select>

                      <Select
                        disabled={selectedType === "inbound"}
                        onValueChange={(val) => {
                          setSelectedType("outbound");
                          setSelectedChannelOption(val);
                        }}
                        value={
                          selectedType === "outbound"
                            ? selectedChannelOption
                            : ""
                        }
                      >
                        <SelectTrigger
                          hideIcon
                          className={`${
                            selectedType === "inbound"
                              ? "hidden"
                              : selectedType !== ""
                                ? "col-span-2"
                                : ""
                          } bg-[#E1EBFC] border-none hover:bg-blue-100 focus:ring-0 focus:ring-offset-0 whitespace-nowrap relative`}
                        >
                          <div className="flex gap-3 items-center">
                            <SelectValue placeholder="Partner contacted" />
                            {!selectedChannelOption && (
                              <ChevronDown className="h-4 w-4 text-blue-600 ml-0 pointer-events-none" />
                            )}
                          </div>
                          {selectedChannelOption && (
                            <X
                              className="h-4 w-4 z-50 text-blue-600 ml-2 cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                setSelectedType("");
                                setSelectedChannelOption("");
                              }}
                            />
                          )}
                        </SelectTrigger>
                        <SelectContent>
                          <SelectGroup>
                            {channel_options_outbound?.map((channel) => {
                              if (
                                [
                                  "Refferal",
                                  "Social Media",
                                  "Chat",
                                  "Walk-in",
                                ].includes(channel?.label)
                              )
                                return null;
                              return (
                                <SelectItem
                                  className="cursor-pointer hover:bg-[#e5eff3]"
                                  key={channel.value}
                                  value={channel.value.toString()}
                                >
                                  {channel.label === "Refferal"
                                    ? "Referral"
                                    : channel.label}
                                </SelectItem>
                              );
                            })}
                          </SelectGroup>
                        </SelectContent>
                      </Select>
                    </div>
                  </>
                )}

                <div className="grid grid-cols-2 gap-3">
                  {isNextBtn ? (
                    <button
                      onClick={handleMobileViewClick}
                      disabled={!nextButtonState()}
                      className="col-span-2 w-full h-12 text-sm text-[#fff] bg-blue-600 rounded-[8px] disabled:opacity-50 shadow-md"
                    >
                      Next
                    </button>
                  ) : (
                    <button
                      onClick={handleAddInteraction}
                      disabled={!buttonState()}
                      className="col-span-2 w-full h-12 text-sm text-[#fff] bg-blue-600 rounded-[8px] disabled:opacity-50 shadow-md"
                    >
                      Submit
                    </button>
                  )}
                </div>

                <div className="grid grid-cols-1 gap-3 mt-4">
                  {productDetails?.name?.toLowerCase() === "visa" && (
                    <button
                      disabled={extraDetails?.quote_requested}
                      className="px-4 py-[11px] text-sm text-center font-semibold border-blue-700 border rounded-lg text-blue-700 cursor-pointer disabled:cursor-not-allowed"
                    >
                      <label
                        htmlFor="upload_letter"
                        className="flex items-center text-center justify-center w-full gap-2.5 cursor-pointer"
                      >
                        <input
                          type="file"
                          id="upload_letter"
                          className="hidden"
                          accept=".pdf"
                          onChange={(e) =>
                            handleQuoteUploadVisa(e?.target?.files?.[0] as File)
                          }
                        />
                        <p>Upload Quotation</p>
                        <svg
                          width="15"
                          height="19"
                          viewBox="0 0 15 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.5 4C0.5 1.79086 2.29086 0 4.5 0H10.0546C10.3381 0 10.6083 0.12032 10.7979 0.33104L14.7433 4.71477C14.9086 4.8984 15 5.13669 15 5.38374V14.5C15 16.7091 13.2091 18.5 11 18.5H4.5C2.29086 18.5 0.5 16.7091 0.5 14.5V4Z"
                            fill="#165FE3"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11.26 10.8978C10.9583 11.1817 10.4837 11.1672 10.1998 10.8655L7.7461 8.25736L5.2923 10.8655C5.0085 11.1672 4.5339 11.1817 4.2322 10.8978C3.9305 10.614 3.916 10.1394 4.1999 9.83766L6.8968 6.97106C7.3603 6.47836 8.1319 6.47836 8.5954 6.97106L11.2923 9.83766C11.5762 10.1394 11.5617 10.614 11.26 10.8978Z"
                            fill="white"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.74609 15.6016C7.33189 15.6016 6.99609 15.2658 6.99609 14.8516V7.35156C6.99609 6.93736 7.33189 6.60156 7.74609 6.60156C8.16029 6.60156 8.49609 6.93736 8.49609 7.35156V14.8516C8.49609 15.2658 8.16029 15.6016 7.74609 15.6016Z"
                            fill="white"
                          />
                          <path
                            d="M14.9922 6V5.38374C14.9922 5.13669 14.9008 4.8984 14.7355 4.71477L10.7901 0.33104C10.6005 0.12032 10.3303 0 10.0468 0H8.99219V2C8.99219 4.20914 10.7831 6 12.9922 6H14.9922Z"
                            fill="#98BDFF"
                          />
                        </svg>
                      </label>
                    </button>
                  )}
                </div>
              </div>
            </SheetContent>
          </Sheet>
        ) : (
          <div className="flex flex-1 justify-end h-full gap-8 sm:px-2 pt-1 rounded-lg items-end p-2.5 bg-white-A700 w-full">
            {contactDetails?.lead_status !== "notinterested" &&
              contactDetails?.lead_status !== "notResponded" &&
              opportunityDetails?.isOpportunityOpen !== "open" &&
              activeTab === "interaction" && (
                <div className="flex flex-col mt-1 w-full">
                  <hr className="" />
                  <div className="flex flex-col gap-2.5">
                    <div className="flex justify-between w-full">
                      <label
                        htmlFor="interaction_note"
                        className="text-sm font-medium"
                      >
                        Add interaction
                      </label>
                      {["6", "2"].includes(selectedChannelOption) && (
                        <EmailPopup notes={interactionNote} />
                      )}
                    </div>
                    <textarea
                      value={interactionNote}
                      onChange={(e) => setInteractionNote(e.target.value)}
                      className="rounded-xl border border-gray-border-gray-lite h-20 w-full"
                      name="interaction_note"
                      id="interaction_note"
                      placeholder="write here..."
                    />
                  </div>
                  <div className="flex w-full flex-wrap md:gap-5 sm:flex-col justify-between sm:items-start sm:gap-5 items-center">
                    {/* My changes */}
                    <div className="grid grid-cols-2 gap-4 mt-2 sm:place-content-start relative place-content-end">
                      {selectedChannelOption &&
                        selectedChannelOption === "3" && (
                          <>
                            <div className="">
                              <form className="w-[300px] sm:w-full" action="">
                                <label
                                  htmlFor="ll"
                                  className="font-medium text-sm whitespace-nowrap leading-[18.2px]"
                                >
                                  Search & add team members
                                </label>
                                <ReactSelect
                                  closeMenuOnSelect={false}
                                  styles={{
                                    control: (provided, state) => ({
                                      ...provided,
                                      zIndex: 0,
                                      borderRadius: ".5rem",
                                      padding: ".3rem",
                                      borderColor: state.isFocused
                                        ? "#165FE3"
                                        : "#333333",
                                      boxShadow: "none",
                                      width: "100%",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 1000,
                                      width: "100%",
                                    }),
                                    container: (provided) => ({
                                      // Added container styles
                                      ...provided,
                                      width: "100%",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }),
                                  }}
                                  components={{
                                    DropdownIndicator: () => (
                                      <div className="pr-1">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g clipPath="url(#clip0_2821_158352)">
                                            <path
                                              d="M10.0991 18.6318L10.0988 18.6318C9.94355 18.6313 9.79483 18.5695 9.68508 18.4597C9.57533 18.35 9.51347 18.2012 9.51301 18.046L9.513 18.0456L9.51149 10.59L2.05583 10.5884L2.04426 10.5884L2.04429 10.588C1.89676 10.5766 1.75897 10.5099 1.65846 10.4013C1.55795 10.2927 1.50211 10.1502 1.50211 10.0022C1.50211 9.85428 1.55795 9.71176 1.65846 9.60317C1.75897 9.49457 1.89676 9.42791 2.04429 9.4165L2.05583 9.4156L2.05583 9.41605L9.51143 9.41453L9.50991 1.95893L9.50992 1.9589C9.50992 1.80302 9.57184 1.65353 9.68206 1.54331C9.79228 1.43308 9.94178 1.37116 10.0977 1.37116M10.0991 18.6318L10.0977 1.37116L10.0977 1.52072L10.0977 1.37116M10.0991 18.6318C10.1763 18.6318 10.2528 18.6167 10.3241 18.5871L10.2669 18.4489L10.3241 18.5871C10.3955 18.5576 10.4603 18.5143 10.5149 18.4597C10.5695 18.4051 10.6128 18.3403 10.6423 18.269L10.5037 18.2116L10.6423 18.269C10.6718 18.1976 10.687 18.1212 10.6869 18.044L10.6869 10.59L18.1425 10.5884C18.1426 10.5884 18.1426 10.5884 18.1426 10.5884C18.2984 10.5884 18.4479 10.5265 18.5581 10.4163C18.6684 10.3061 18.7303 10.1566 18.7303 10.0007C18.7303 9.84482 18.6684 9.69532 18.5581 9.5851C18.4479 9.47488 18.2984 9.41295 18.1425 9.41295L18.1425 9.41295L10.6869 9.41447L10.6854 1.9589C10.6854 1.95889 10.6854 1.95888 10.6854 1.95887C10.6854 1.803 10.6235 1.65352 10.5133 1.54331C10.403 1.43308 10.2535 1.37116 10.0977 1.37116M10.0991 18.6318L10.0977 1.37116"
                                              fill="#165FE3"
                                              stroke="#165FE3"
                                              stroke-width="0.3"
                                            />
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_2821_158352">
                                              <rect
                                                width="14"
                                                height="14"
                                                fill="white"
                                                transform="translate(0.203125 10) rotate(-45)"
                                              />
                                            </clipPath>
                                          </defs>
                                        </svg>
                                      </div>
                                    ),
                                    IndicatorSeparator: () => null,
                                    MultiValue: ({ children, ...props }) => {
                                      const { selectProps } = props;
                                      const selectedCount =
                                        selectProps.value.length;

                                      // Only render the first item
                                      if (props.index === 0) {
                                        return (
                                          <div className="flex items-center">
                                            {children}
                                            {selectedCount > 1 && (
                                              <span className="ml-2 text-sm text-gray-500">
                                                +{selectedCount - 1}
                                              </span>
                                            )}
                                          </div>
                                        );
                                      }

                                      // Return null for subsequent selections
                                      return null;
                                    },
                                  }}
                                  isMulti
                                  name="people"
                                  // value={selectedStaffOptions}
                                  onChange={(val) =>
                                    setSelectedStaffOptions(val as Option[])
                                  }
                                  options={staffs}
                                  menuPlacement="top"
                                  className="rounded-lg w-full"
                                  placeholder="Select Staff"
                                />
                              </form>
                            </div>
                            <form action="">
                              <label
                                htmlFor="ll"
                                className="font-medium text-sm leading-[18.2px]"
                              >
                                Select team
                              </label>
                              <DateTimePicker
                                fromDate={new Date("2000-01-01")}
                                date={meetingTime}
                                setDate={setMeetingTime}
                              />
                            </form>
                          </>
                        )}
                      {selectedChannelOption === "3" && (
                        <div className=" space-y-2">
                          <div className="flex items-center justify-between border rounded-md h-12 py-2 px-3.5">
                            <div className="flex items-center gap-2">
                              <svg
                                width="17"
                                height="22"
                                viewBox="0 0 17 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.078 21.529H13.3007C15.2935 21.529 16.2849 20.5183 16.2849 18.516V9.77561C16.2849 8.53361 16.1502 7.99475 15.3801 7.20536L10.0663 1.80529C9.33523 1.05409 8.73805 0.890625 7.65048 0.890625L3.078 0.890625C1.09507 0.890625 0.09375 1.91084 0.09375 3.91348L0.09375 18.516C0.09375 20.5277 1.09507 21.529 3.078 21.529ZM3.1548 19.9794C2.16334 19.9794 1.64338 19.4496 1.64338 18.4873L1.64338 3.94223C1.64338 2.98938 2.16334 2.44025 3.16466 2.44025H7.43855V8.03336C7.43855 9.2462 8.05463 9.84297 9.24816 9.84297H14.7353V18.4873C14.7353 19.4496 14.2248 19.9794 13.2239 19.9794H3.1548ZM9.42148 8.38904C9.04609 8.38904 8.89166 8.23543 8.89166 7.85018V2.73884L14.4363 8.38945L9.42148 8.38904Z"
                                  fill="#5E5E5E"
                                />
                              </svg>
                              <span className="text-gray-500 truncate max-w-[150px] inline-block">
                                {visitingCard.filename
                                  ? visitingCard.filename
                                  : "Visiting Card"}
                              </span>
                            </div>

                            <label
                              htmlFor="visiting_card"
                              className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 text-blue-700 border-blue-700 cursor-pointer"
                            >
                              Upload
                            </label>
                            <Input
                              id="visiting_card"
                              type="file"
                              className="hidden"
                              onChange={async (e) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                  const base64 =
                                    await convertFileToBase64(file);
                                  setVisitingCard({
                                    filename: file.name,
                                    fileBase64: base64 as string,
                                    filetype: file.type,
                                  });
                                }
                              }}
                            />
                          </div>
                        </div>
                      )}
                      {selectedChannelOption === "3" && (
                        <Select
                          value={selectedContact}
                          onValueChange={(val) => {
                            setSelectedContact(val);
                          }}
                        >
                          <SelectTrigger className="w-[180px] whitespace-nowrap">
                            <SelectValue placeholder="Contacted with" />
                          </SelectTrigger>
                          <SelectContent>
                            {!teamMember?.length ? (
                              <Skeleton className="h-4 bg-gray-600 w-full rounded-full" />
                            ) : (
                              teamMember?.map((item) => (
                                <SelectItem
                                  key={item?.id}
                                  value={String(item?.id)}
                                >
                                  {item?.full_name}
                                </SelectItem>
                              ))
                            )}
                          </SelectContent>
                        </Select>
                      )}
                      <Select
                        disabled={contactType === "outbound"}
                        onValueChange={(val) => {
                          if (val !== "3") {
                            setSelectedStaffOptions([]);
                            setMeetingTime(undefined);
                            setVisitingCard({
                              filename: "",
                              fileBase64: "",
                              filetype: "",
                            });
                          }
                          setContactType("inbound");
                          setSelectedChannelOption(val);
                        }}
                        value={
                          contactType === "inbound" ? selectedChannelOption : ""
                        }
                      >
                        <SelectTrigger
                          className={`${
                            contactType === "outbound" ? "hidden" : ""
                          } bg-[#F9F9F9] border-none hover:bg-blue-100 focus:ring-0 whitespace-nowrap focus:ring-offset-0 [&>svg]:hidden`}
                        >
                          <SelectValue placeholder="I contacted" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectGroup>
                            {channel_options_inbound.map((channel) => (
                              <SelectItem
                                className="cursor-pointer hover:bg-[#e5eff3]"
                                key={channel.value}
                                value={channel.value.toString()}
                              >
                                {channel.label}
                              </SelectItem>
                            ))}
                          </SelectGroup>
                        </SelectContent>
                      </Select>

                      <Select
                        disabled={contactType === "inbound"}
                        onValueChange={(val) => {
                          if (val !== "3") {
                            setSelectedStaffOptions([]);
                            setMeetingTime(undefined);
                            setVisitingCard({
                              filename: "",
                              fileBase64: "",
                              filetype: "",
                            });
                          }
                          setContactType("outbound");
                          setSelectedChannelOption(val);
                        }}
                        value={
                          contactType === "outbound"
                            ? selectedChannelOption
                            : ""
                        }
                      >
                        <SelectTrigger
                          className={`${
                            contactType === "inbound" ? "hidden" : ""
                          } bg-[#F9F9F9] border-none hover:bg-blue-100 focus:ring-0 focus:ring-offset-0 whitespace-nowrap [&>svg]:hidden`}
                        >
                          <SelectValue placeholder="Partner contacted" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectGroup>
                            {channel_options_outbound.map((channel) => {
                              if (
                                [
                                  "Refferal",
                                  "Social Media",
                                  "Chat",
                                  "Walk-in",
                                ].includes(channel.label)
                              )
                                return null;
                              return (
                                <SelectItem
                                  className="cursor-pointer hover:bg-[#e5eff3]"
                                  key={channel.value}
                                  value={channel.value.toString()}
                                >
                                  {channel.label === "Refferal"
                                    ? "Referral"
                                    : channel.label}
                                </SelectItem>
                              );
                            })}
                            <SelectItem
                              className="cursor-pointer hover:bg-[#e5eff3]"
                              value={"3"}
                            >
                              Meeting
                            </SelectItem>
                          </SelectGroup>
                        </SelectContent>
                      </Select>
                      {selectedChannelOption && (
                        <button
                          className="self-center"
                          onClick={() => {
                            setContactType("");
                            setSelectedChannelOption("");
                            setVisitingCard({
                              filename: "",
                              fileBase64: "",
                              filetype: "",
                            });
                          }}
                        >
                          <XIcon
                            color="#165FE3"
                            className="w-4 border border-blue-700 rounded-full bg-[#E1EBFC] h-4"
                          />
                        </button>
                      )}
                    </div>
                    <div className=" flex-1 justify-end md:justify-start flex flex-wrap sm:flex-col gap-2 w-full">
                      {["Forex", "Remittance"].includes(
                        opportunityDetails?.productSubcategory as string,
                      ) && (
                        <button
                          onClick={handlePrepareQuote}
                          disabled={!buttonState()}
                          className="px-4 hidden py-[11px] text-sm font-semibold rounded-lg text-blue-700 border-blue-700 border disabled:opacity-40"
                        >
                          Prepare Quotes
                        </button>
                      )}
                      <AlertDialog
                        open={dialogOpen}
                        onOpenChange={setDialogOpen}
                      >
                        <AlertDialogTrigger asChild>
                          <button
                            className="px-4 py-[11px] text-sm font-semibold rounded-lg bg-blue-700 text-white-A700 disabled:opacity-40"
                            onClick={handleClick}
                            disabled={!buttonState()}
                          >
                            Submit
                          </button>
                        </AlertDialogTrigger>
                        <AlertDialogPortal>
                          <AlertDialogOverlay className="bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
                          <AlertDialogContent className="bg-white-A700 rounded-lg p-0 max-w-2xl w-full animate-contentShow sm:max-w-[90%]">
                            <AlertDialogHeader className="flex text-left border-b rounded-t py-5 px-10">
                              <AlertDialogTitle className="font-bold capitalize p-0 text-lg text-black-label">
                                Upload Picture
                              </AlertDialogTitle>
                            </AlertDialogHeader>
                            <FormProvider {...methods2}>
                              <div className="h-auto max-h-[80vh] overflow-auto w-full">
                                <PhotoUpload />
                              </div>
                            </FormProvider>
                            <AlertDialogFooter className="flex justify-start items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
                              <AlertDialogCancel
                                className="m-0 rounded-lg border-blue-700 border py-[11px] px-4 text-blue-700"
                                asChild
                              >
                                <button
                                  onClick={() => {
                                    methods2.reset();
                                    methods2.clearErrors();
                                    setDialogOpen(false);
                                  }}
                                >
                                  Cancel
                                </button>
                              </AlertDialogCancel>
                              <AlertDialogAction
                                className="rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700 disabled:opacity-40"
                                asChild
                              >
                                <button
                                  disabled={
                                    !methods2.watch("office_photo") ||
                                    location === null
                                  }
                                  onClick={handleAddInteraction}
                                >
                                  Done
                                </button>
                              </AlertDialogAction>
                            </AlertDialogFooter>
                          </AlertDialogContent>
                        </AlertDialogPortal>
                      </AlertDialog>

                      <div className="hidden">
                        {pipelineType === "retail" &&
                          opportunityDetails?.productSubcategory !==
                            "Remittance" && (
                            <DocPopup
                              buttonState={buttonState}
                              onSubmit={handleRequestDoc}
                              selectedMode={selectedMode}
                              setSelectedMode={setSelectedMode}
                              expires={expires}
                              setExpires={setExpires}
                              popupnotes={popupnotes}
                              setPopupNotes={setPopupNotes}
                              channel={channel}
                              setChannel={setChannel}
                            />
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Partnerleaddetail;
